import React, { Component } from 'react'
import { connect } from 'react-redux'
import InfoScreens from '../InfoScreens'
import { OverlayTrigger, Overlay, Popover } from 'react-bootstrap'
import $ from 'jquery'
import _ from 'underscore'
import classNames from 'classnames'
import { Pie } from 'react-chartjs-2'
import { Chart, ArcElement } from 'chart.js'
Chart.register(ArcElement)
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import {
  infoScreenConnectLabel,
  feedbackAriaLabel,
  contentSectionAriaLabel,
  editModalAriaLabel,
} from '../Constants/AriaLabelText'
import { sectionUnderscore } from '../Constants/UniversalMapping'
import {
  divisionSubHeadlineText,
  languageContent,
  impactContent,
  presentationContent,
  feedbackContent,
  emptySectionMessage,
} from '../Constants/DetailedFeedbackText'
import { InfoComponent } from '../HelperComponent/FeedbackBlock'
import { fetchCustomisation, checkIfEmpty } from '../../services/helpers'
import { CircularBar } from '@vmockinc/dashboard/Common/commonComps/ProgressBar'
import {
  fetchResumeGap,
  updateResumeGapState,
} from '../../actions/AspireResumeGap'
import { fetchEditDynamicData } from '../../actions/AspireEditDynamicData'
import { cleanWord } from '../../services/detailed_feedback'
import { injectIntl, FormattedMessage } from 'react-intl'
import { showEditModal } from '../../actions/Edit'
import { redirectSelect } from '../../actions/AspireFeedback'
import { selectSection } from '../../actions/DetailedFeedback'
import { hashLinkScroll } from '../../services/helpers'
import { getLanguageSpecificAssetUrl } from '@vmockinc/dashboard/services/helpers'

const minRelevantCategories = {
  Headline: 4,
  Summary: 8,
  Experience: 4,
  Education: 5,
}

const sectionNavs = {
  Headline: ['content', 'skills', 'visibility'],
  Summary: ['content', 'skills', 'visibility'],
  Experience: ['content', 'skills', 'visibility'],
  Education: ['content', 'visibility'],
}

const sectionNameMap = {
  Headline: 'aspire.headline.heading.headline',
  Summary: 'aspire.summary.heading',
  Experience: 'aspire.experience.headingExperience',
  Education: 'aspire.education.heading',
}



const moduleToNavMapping = {
  skills: 'skills',
  seo: 'visibility',
  categories: 'content',
  impact: 'content',
  language: 'content',
}

const symbolMap = {
  green: <span className="fa fa-check" aria-hidden="true" />,
  yellow: <span className="fa fa-exclamation" aria-hidden="true" />,
  red: <span className="fa fa-times" aria-hidden="true" />,
}

const iconMap = {
  green: 'icon-good-job.svg',
  yellow: 'icon-on-track.svg',
  red: 'icon-needs-work.svg',
}

const minWordCounts = {
  Summary: 100,
  Experience: 50,
}


const sectionFeedbackKeyName = {
  Headline: 'headline_feedback',
  Summary: 'summary_feedback',
  Experience: 'experience_feedback',
  Education: 'education_feedback',
}


const modsMap = {
  content: 'Content',
  skills: 'Skills',
  visibility: 'Profile Visibility',
}

const modsMessages = {
  content: {
    id: "aspire.sections.mod.content",
    defaultMessage: "Content"
  },
  skills: {
    id: "aspire.sections.mod.skills",
    defaultMessage: "Skills"
  },
  visibility: {
    id: "aspire.sections.mod.visibility",
    defaultMessage: "Profile Visibility"
  }
};


class Sections extends Component {


  constructor(props) {
    super(props)
    this.state = {
      sectionAnimation: true,
      selectedModule: '',
      selectedValue: '',
      hoveredModule: '',
      hoveredValue: '',
      selectedLanguageImpact: '',
      selectedPresentation: '',
      showInfoScreen: false,
      activeInfoScreen: '',
      informationCategoryOpen: false,
      skillInclusionOpen: false,
      seoKeywordOpen: false,
      languageOpen: false,
      impactOpen: false,
      presentationOpen: false,
      skillsResumeOpen: false,
      skillsResumeIndex: 0,
      selectedPresentCategory: '',
      selectedSkill: '',
      checkbox: {
        tense: false,
        narrative_voice: false,
        buzzwords: false,
        verb_overusage: false,
        action_oriented: false,
        specifics: false,
      },
      checkboxPresentation: {
        grammar: false
      }
    }
    this.sectionEmpty = false
    this.emptyDescription = false
    this.renderModuleFeedback = {
      categories: true,
      impact: true,
      language: true,
      presentation: true,
      skills: true,
      seo: true,
    }
    this.idsObj = null
    this.sectionSamples = 0
    this.prevSelectedValue = ''
    this.prevSelectedModule = ''
    this.firstKeywordButton = {
      categories: '',
      skills: '',
      seo: '',
    }
    this.tabIndexLanguageImpact = {
      action_oriented: 11,
      specifics: 11,
      buzzwords: 11,
      verb_overusage: 11,
      tense: 11,
      narrative_voice: 11,
    }
    this.tabIndexPresentation = {
      length: 11,
      paragraphs: 11,
      grammar: 11,
    }
    this.dynamicTabIndexing = 11
    this.showInfoModal = this.showInfoModal.bind(this)
    this.renderImpactZero = this.renderImpactZero.bind(this)
    this.renderPresentationZero = this.renderPresentationZero.bind(this)
    this.hideInfoModal = this.hideInfoModal.bind(this)
    this.handleSectionAnimation = this.handleSectionAnimation.bind(this)
    this.handleGraySkillsSeoTracking =
      this.handleGraySkillsSeoTracking.bind(this)
    this.handleResumeSkillsTracking = this.handleResumeSkillsTracking.bind(this)
    this.handleOtherSkillsTracking = this.handleOtherSkillsTracking.bind(this)
    this.handleGrayCategoriesTracking =
      this.handleGrayCategoriesTracking.bind(this)
    this.handleResumeCategoriesTracking =
      this.handleResumeCategoriesTracking.bind(this)
    this.sendTrackingDataDebounceInfoModal = _.debounce(
      sendTrackingData,
      5000,
      true
    )
    this.sendTrackingDataDebounceOtherClicks = _.debounce(
      sendTrackingData,
      5000,
      true
    )
    this.sendTrackingDataDebounceResumeClicks = _.debounce(
      sendTrackingData,
      5000,
      true
    )
    this.sendTrackingDataDebounceGraySkillsSeo = _.debounce(
      sendTrackingData,
      5000,
      true
    )
    this.sendTrackingDataDebounceGrayCategories = _.debounce(
      sendTrackingData,
      5000,
      true
    )
    this.trackPresentCategoriesClick = _.debounce(sendTrackingData, 3000, true)
    this.trackResumeSkills = _.debounce(sendTrackingData, 3000, true)
    this.handlePrev = this.handlePrev.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handleResumeSkillClick = this.handleResumeSkillClick.bind(this)
    this.setSelectedPresentCategory = this.setSelectedPresentCategory.bind(this)
    this.updateCheckboxState = this.updateCheckboxState.bind(this)
    this.updateCheckboxPresentationState = this.updateCheckboxPresentationState.bind(this)
    this.wordCountFeedback = (isUKEnable) => ({
      Headline: [
        '100+',
        this.props.intl.formatMessage({
          id: 'aspire.sections.wordCountFeedback.headline',
          defaultMessage:
            'Optimize your 220 characters by including keywords that highlight your skills for the selected functional area.',
        }),
      ],
      Summary: [
        '100+',
        this.props.intl.formatMessage({
          id: 'aspire.sections.wordCountFeedback.summary',
          defaultMessage:
            'Keep the length of your summary section between 100-300 words. Give people a 360º view of yourself as a person as well as a professional.',
        }),
      ],
      Experience: [
        '50+',
        this.props.intl.formatMessage({
          id: 'aspire.sections.wordCountFeedback.experience',
          defaultMessage:
            'Utilize description section of experience to highlight achievements and relevant expertise in at least 50 words.',
        }),
      ],
    })
    this.textMap = {
      green: this.props.intl.formatMessage({
        id: 'aspire.sections.textMap.green',
        defaultMessage: 'Good Job!',
      }),
      yellow: this.props.intl.formatMessage({
        id: 'aspire.sections.textMap.yellow',
        defaultMessage: 'On Track!',
      }),
      red: this.props.intl.formatMessage({
        id: 'aspire.sections.textMap.red',
        defaultMessage: 'Needs Work!',
      }),
    }
    this.overlayMapDesc = {
      green: this.props.intl.formatMessage({
        id: 'aspire.sections.overlayMapDesc.green',
        defaultMessage: 'You have done a good job with this section.',
      }),
      yellow: this.props.intl.formatMessage({
        id: 'aspire.sections.overlayMapDesc.yellow',
        defaultMessage: 'Consider the feedback to improve this section.',
      }),
      red: this.props.intl.formatMessage({
        id: 'aspire.sections.overlayMapDesc.red',
        defaultMessage: 'Consider the feedback to improve this section.',
      }),
    }
  }

  UNSAFE_componentWillMount() {
    const {
      ui,
      sectionWiseTextStatic,
      sectionWiseText,
      currentSection,
      sectionWiseTextIntermediateSkills,
      sectionWiseTextEditable,
      fetchingSkills,
      fetchedSkills,
      loaderInput,
    } = this.props
    const currentIndex = ui.currentIndex
    this.sectionEmpty = this.isSectionEmpty(
      currentSection,
      sectionWiseText[sectionUnderscore[currentSection]]
    )
    this.emptyDescription = this.checkEmptyDescription(
      sectionWiseTextStatic,
      currentIndex
    )
    this.toRenderModuleFeedback(this.props)
    this.getFirstModuleKeywords(this.props)
    let defaultSelectedValue = this.getDefaultSelectedValue(
      sectionNavs[currentSection][0],
      this.props
    )
    this.idsObj = defaultSelectedValue['idsObj']
    let selectedLanguageImpact =
      defaultSelectedValue['module'] == 'language' ||
      defaultSelectedValue['module'] == 'impact'
        ? defaultSelectedValue['value']
        : ''
    
    let selectedPresentation =
      defaultSelectedValue['module'] == 'presentation'
        ? defaultSelectedValue['value']
        : ''

    let sectionNav = moduleToNavMapping[defaultSelectedValue['module']]
    let countOfAvailableClick = this.getNoOfModules(sectionNav)

    this.setState({
      hoveredValue: '',
      hoveredModule: '',
      selectedValue: defaultSelectedValue['value'],
      selectedModule: defaultSelectedValue['module'],
      selectedLanguageImpact: selectedLanguageImpact,
      selectedPresentation: selectedPresentation,
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      ui,
      sectionWiseTextStatic,
      sectionWiseText,
      currentSection,
      currentIndex,
      activeNavIndex,
      update_detailed_state,
      sectionWiseTextEditable,
    } = nextProps

    if (
      currentSection != this.props.currentSection ||
      currentIndex != this.props.currentIndex ||
      update_detailed_state !== this.props.update_detailed_state
    ) {
      this.sectionEmpty = this.isSectionEmpty(
        currentSection,
        sectionWiseText[sectionUnderscore[currentSection]]
      )
      this.emptyDescription = this.checkEmptyDescription(
        sectionWiseTextStatic,
        currentIndex
      )
      this.toRenderModuleFeedback(nextProps)
      this.getFirstModuleKeywords(nextProps)
      let defaultSelectedValue = this.getDefaultSelectedValue(
        sectionNavs[currentSection][activeNavIndex],
        nextProps
      )
      this.prevSelectedValue = ''
      this.prevSelectedModule = ''
      this.idsObj = defaultSelectedValue['idsObj']
      let selectedLanguageImpact =
        defaultSelectedValue['module'] == 'language' ||
        defaultSelectedValue['module'] == 'impact'
          ? defaultSelectedValue['value']
          : ''

      let selectedPresentation =
        defaultSelectedValue['module'] == 'presentation'
          ? defaultSelectedValue['value']
          : ''

      this.setState({
        hoveredValue: '',
        hoveredModule: '',
        selectedValue: defaultSelectedValue['value'],
        selectedModule: defaultSelectedValue['module'],
        selectedLanguageImpact: selectedLanguageImpact,
        selectedPresentation: selectedPresentation,
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      currentSection,
      currentIndex,
      feedback,
      fetchResumeGap,
      hasResume,
      newSubSection,
      fetchId,
    } = this.props
    this.handleSelection()
    this.getLanguageImpactTabIndex()
    if (
      prevProps.currentSection !== currentSection ||
      prevProps.currentIndex !== currentIndex
    ) {
      if (
        !(currentSection === 'Education' || currentSection === 'Experience') ||
        currentIndex !== null
      ) {
        this.setState({
          languageOpen: false,
          impactOpen: false,
          informationCategoryOpen: true,
          skillInclusionOpen: true,
          seoKeywordOpen: true,
        })
      }
      if (
        !['Headline', 'Summary', 'Experience', 'Education'].includes(currentSection) ||
        currentIndex !== null
      ) {
        this.setState({
          presentationOpen: false,
        })
      }
      if (['Summary', 'Experience'].includes(currentSection)) {
        if (hasResume == 1) {
          if (newSubSection == true) {
            fetchResumeGap(fetchId, currentSection, -1)
          } else {
            fetchResumeGap(fetchId, currentSection, currentIndex)
          }
        }
      }
    }

    if (!prevProps.newSubSection && newSubSection) {
      this.setState({
        languageOpen: false,
        impactOpen: false,
        presentationOpen: false,
        informationCategoryOpen: true,
        skillInclusionOpen: true,
        seoKeywordOpen: true,
      })
    }

    const { selectedModule, selectedValue } = this.state
    if (
      ((['skills', 'seo'].includes(prevState.selectedModule) &&
        selectedModule === 'categories' &&
        this.state.impactOpen) ||
        (!prevState.impactOpen && this.state.impactOpen)) &&
      _.isEmpty(this.state.selectedLanguageImpact)
    ) {
      if (this.renderModuleFeedback['impact']) {
        this.setState({
          selectedLanguageImpact: 'action_oriented',
        })
      } else {
        this.setState({
          selectedLanguageImpact: 'buzzwords',
        })
      }
    }

    if (
      ((['skills', 'seo'].includes(prevState.selectedModule) &&
        selectedModule === 'categories' &&
        this.state.presentationOpen) ||
        (!prevState.presentationOpen && this.state.presentationOpen)) &&
      _.isEmpty(this.state.selectedPresentation)
    ) {
      if (this.renderModuleFeedback['presentation']) {
        this.setState({
          selectedPresentation: 'bullet_length',
        })
      }
    }

    if (
      (!prevProps.isEditModal && this.props.isEditModal) ||
      (this.props.isEditModal &&
        (prevState.selectedModule !== selectedModule ||
          prevState.selectedValue !== selectedValue))
    ) {
      this.props.unhighlightAllEdit()
      if (['categories', 'skills', 'seo'].includes(selectedModule)) {
        this.handlePresentModuleCategoryClick(selectedValue)
      } else if (selectedModule === 'impact' || selectedModule === 'language') {
        this.handleImpactModulesClick(selectedModule, selectedValue)
      } else if (selectedModule === 'presentation') {
        this.handlePresentationModulesClick(selectedModule, selectedValue)
      }
    }
  }

  componentWillUnmount() {
    const { updateResumeGapState } = this.props
    updateResumeGapState({
      updateKeys: [['fetched'], ['fetching'], ['data'], ['error']],
      data: { fetched: false, fetching: false, data: null, error: null },
    })
  }

  validateFeedbackDataCategories(category) {
    const { feedback, ui, currentSection, currentIndex } = this.props
    if (
      feedback.hasOwnProperty(category) &&
      !_.isEmpty(feedback[category]) &&
      feedback[category].hasOwnProperty('score') &&
      feedback[category]['score'].hasOwnProperty(currentIndex)
    ) {
      return true
    }
    return false
  }

  componentDidMount() {
    const {
      feedback,
      ui,
      currentSection,
      currentIndex,
      fetchResumeGap,
      hasResume,
      newSubSection,
      fetchId,
    } = this.props

    this.handleSelection()
    this.getLanguageImpactTabIndex()
    if (
      !(currentSection === 'Education' || currentSection === 'Experience') ||
      currentIndex !== null
    ) {
      this.setState({
        languageOpen: false,
        impactOpen: false,
        informationCategoryOpen: true,
        skillInclusionOpen: true,
        seoKeywordOpen: true,
      })
    }
    if (
      !(currentSection === 'Headline' || currentSection === 'Summary' || currentSection === 'Experience' || currentSection === 'Education') ||
      currentIndex !== null
    ) {
      this.setState({
        presentationOpen: false,
      })
    }
    if (['Summary', 'Experience'].includes(currentSection)) {
      if (hasResume == 1) {
        if (newSubSection == true) {
          fetchResumeGap(fetchId, currentSection, -1)
        } else {
          fetchResumeGap(fetchId, currentSection, currentIndex)
        }
      }
    }
  }

  toRenderModuleFeedback(props) {
    const { currentIndex, currentSection, feedback } = props
    let renderHeadLineLanguage = true

    if (currentSection == 'Headline') {
      let params = ['buzzwords', 'verb_overusage', 'tense', 'narrative_voice']
      params = _.filter(params, function (value) {
        return (
          feedback['language'].hasOwnProperty(value) &&
          !_.isEmpty(feedback['language'][value]) &&
          feedback['language'][value].hasOwnProperty(currentIndex)
        )
      })

      renderHeadLineLanguage = false

      for (let key in params) {
        if (
          feedback['language'][params[key]][currentIndex]['color'] != 'green'
        ) {
          renderHeadLineLanguage = true
          break
        }
      }
    }

    this.renderModuleFeedback = {
      categories: !(
        this.sectionEmpty === true ||
        _.isUndefined(feedback['categories']) ||
        _.isUndefined(feedback['categories']['score']) ||
        !feedback['categories']['score'].hasOwnProperty(currentIndex) ||
        !feedback['categories']['score'][currentIndex].hasOwnProperty(
          'color'
        ) ||
        _.isNull(feedback['categories']['score'][currentIndex]['color'])
      ),
      impact: !(
        this.sectionEmpty === true ||
        this.emptyDescription == true ||
        _.isUndefined(feedback['impact']) ||
        _.isUndefined(feedback['impact']['score']) ||
        !feedback['impact']['score'].hasOwnProperty(currentIndex) ||
        !feedback['impact']['score'][currentIndex].hasOwnProperty('color') ||
        _.isNull(feedback['impact']['score'][currentIndex]['color'])
      ),
      language:
        !(
          this.sectionEmpty === true ||
          this.emptyDescription === true ||
          _.isUndefined(feedback['language']) ||
          _.isUndefined(feedback['language']['score']) ||
          _.isUndefined(feedback['language']['score'][currentIndex]) ||
          !feedback['language']['score'][currentIndex].hasOwnProperty(
            'color'
          ) ||
          _.isNull(feedback['language']['score'][currentIndex]['color'])
        ) && renderHeadLineLanguage,
      presentation: !(
        this.sectionEmpty === true ||
        this.emptyDescription === true ||
        _.isUndefined(feedback['presentation']) ||
        _.isUndefined(feedback['presentation']['score']) ||
        !feedback['presentation']['score'].hasOwnProperty(currentIndex) ||
        !feedback['presentation']['score'][currentIndex].hasOwnProperty('color') ||
        _.isNull(feedback['presentation']['score'][currentIndex]['color'])
      ),
      skills: !(
        this.sectionEmpty === true ||
        _.isUndefined(feedback['skills']) ||
        _.isUndefined(feedback['skills']['score']) ||
        !feedback['skills']['score'].hasOwnProperty(currentIndex) ||
        !feedback['skills']['score'][currentIndex].hasOwnProperty('color') ||
        _.isNull(feedback['skills']['score'][currentIndex]['color'])
      ),
      seo: !(
        this.sectionEmpty === true ||
        _.isUndefined(feedback['seo']) ||
        _.isUndefined(feedback['seo']['score']) ||
        !feedback['seo']['score'].hasOwnProperty(currentIndex) ||
        !feedback['seo']['score'][currentIndex].hasOwnProperty('color') ||
        _.isNull(feedback['seo']['score'][currentIndex]['color'])
      ),
    }
  }

  requireWordCountFeedback(feedback, currentIndex) {
    return (
      !_.isUndefined(feedback['word_count_class']) &&
      !_.isUndefined(feedback['word_count_class'][currentIndex]) &&
      feedback['word_count_class'][currentIndex]['color'] == 'red'
    )
  }

  checkWordCountLow(feedback, currentSection, currentIndex) {
    return (
      !_.isUndefined(feedback['word_count_class']) &&
      !_.isUndefined(feedback['word_count_class'][currentIndex]) &&
      feedback['word_count_class'][currentIndex]['color'] == 'red' &&
      feedback['word_count_class'][currentIndex]['count'] <
        minWordCounts[currentSection]
    )
  }

  checkEmptyDescription(sectionWiseTextEditable, currentIndex) {
    return (
      sectionWiseTextEditable.hasOwnProperty(currentIndex) &&
      sectionWiseTextEditable[currentIndex].hasOwnProperty('text') &&
      _.isEmpty(sectionWiseTextEditable[currentIndex]['text'])
    )
  }

  findAllPositions(text, word) {
    const positions = [];
    if (!word || !text) return positions;
    const trimmedStartMatch = text.match(/^[\s*\-•‣⁃◦▪▫<>]*(.*)$/);
    if (!trimmedStartMatch) return positions; 
    const trimmedText = trimmedStartMatch[1];
    const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regexStr = `(^|[^A-Za-z0-9_])(${escaped})($|[^A-Za-z0-9_])`;
    const regex = new RegExp(regexStr, 'gi');
    let match;
    while ((match = regex.exec(trimmedText)) !== null) {
      const phraseStart = match.index + match[1].length;
      positions.push(phraseStart);
      regex.lastIndex = phraseStart + word.length;
    }
    return positions;
  }

  buildGrammarIdsObj(grammarWords) {
    const idsObj = { ids: {} };
    for (let divId in grammarWords) {
      idsObj.ids[divId] = [];
      const words = grammarWords[divId];
      let el = document.querySelector(`.hwt-input`)
      if(!el) el = document.querySelector('.div-id-' + divId);
      if(!el) continue;
      const text = el.textContent || '';
      for (let word of words) {
          const positions = this.findAllPositions(text, word);
          for (let pos of positions) {
            idsObj.ids[divId].push({ word, pos });
          }
      }
    }
    return idsObj;
  }

  renderCountFeedback(
    feedback,
    currentSection,
    currentIndex,
    has_api,
    has_pdf,
    tabIndex,
    isUKEnable
  ) {
    if (
      this.requireWordCountFeedback(feedback, currentIndex) === true &&
      this.sectionEmpty === false
    ) {
      let style = {}

      if (this.wordCountFeedback(isUKEnable)[currentSection][0].length > 3) {
        style = { width: '87px', fontSize: '29px' }
      } else {
        style = { width: '87px' }
      }

      if (
        currentSection == 'Summary' &&
        feedback['word_count_class'][currentIndex]['count'] > 300
      ) {
        return (
          <div className="ps-detail-num">
            <div className="ps-num" style={style}>
              {' '}
              300-{' '}
            </div>
            <div className="ps-content">
              <p>
                {' '}
                {this.props.intl.formatMessage({
                  id: 'aspire.sections.wordCountFeedback.summaryOver300',
                  defaultMessage:
                    'Keep the length of your about section between 100-300 words. Give people a 360º view of yourself as a person as well as a professional.',
                })}{' '}
              </p>
            </div>
          </div>
        )
      }

      return (
        <div className="ps-detail-num">
          <div className="ps-num" style={style}>
            {' '}
            {this.wordCountFeedback(isUKEnable)[currentSection][0]}{' '}
          </div>
          <div className="ps-content">
            <p> {this.wordCountFeedback(isUKEnable)[currentSection][1]} </p>
          </div>
        </div>
      )
    } else if (
      !_.isUndefined(feedback['experience_count']) &&
      feedback['experience_count'] == 'red'
    ) {
      if (has_api === 1 && has_pdf !== 1) {
        return (
          <div className="ps-detail-num">
            <div className="ps-content">
              <p>
                {' '}
                {this.props.intl.formatMessage({
                  id: 'aspire.sections.experienceCountFeedback.noCurrent',
                  defaultMessage:
                    'You have not mentioned your current experience. Consider including experience, school or positions of responsibility as a current experience.',
                })}{' '}
              </p>
            </div>
          </div>
        )
      } else {
        return (
          <div className="ps-detail-num">
            <div className="ps-num"> 2+ </div>
            <div className="ps-content">
              <p>
                {' '}
                {this.props.intl.formatMessage({
                  id: 'aspire.sections.experienceCountFeedback.minExperiences',
                  defaultMessage:
                    'Make sure that you include at least 3 experiences in this section, one current experience and two past experiences.',
                })}{' '}
              </p>
            </div>
          </div>
        )
      }
    } else {
      return null
    }
  }

  renderSectionBulletFeedback(feedback, currentSection, currentIndex) {
    const { removeBulletPointSuggestion = false } = this.props
    if (
      !removeBulletPointSuggestion &&
      !_.isUndefined(feedback['sub_section_bullet_feedback']) &&
      !_.isUndefined(feedback['sub_section_bullet_feedback'][currentIndex]) &&
      feedback['sub_section_bullet_feedback'][currentIndex]['color_feedback'] ==
        'red'
    ) {
      return (
        <div className="ps-detail-orange">
          <div className="ps-content-2">
            <p>
              {' '}
              <strong>
                {this.props.intl.formatMessage({
                  id: 'aspire.sections.bulletFormFeedbackTitle',
                  defaultMessage: 'BULLET FORM :',
                })}
              </strong>{' '}
              {this.props.intl.formatMessage({
                id: 'aspire.sections.bulletFormFeedback',
                defaultMessage:
                  'The {currentSection} section is better written in form of bullets.',},
                { currentSection : intl.formatMessage({id : sectionNameMap[currentSection]}) },
              )}{' '}
            </p>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  getLanguageImpactAriaLabel(
    feedback,
    params,
    currentIndex,
    currentSection,
    moduleSelected
  ) {
    const { intl } = this.props
    let ariaLabel = {}
    _.mapObject(params, (value, key) => {
      let label = []
      if (feedback[moduleSelected][value][currentIndex]['color'] != 'green') {
        label.push(
          contentSectionAriaLabel(intl)[moduleSelected][currentSection]['red'][value]
        )
        _.map(
          feedback[moduleSelected][value][currentIndex]['ids'],
          (value, key) => {
            for (let id = 0; id < value.length; id++) {
              if (label.indexOf(value[id].word) === -1) {
                // label.push(`Keyword highlighted ${value[id].word}`)
                label.push(
                  this.props.intl.formatMessage({
                    id: 'aspire.sections.languageImpact.keywordHighlighted',
                    defaultMessage: 'Keyword highlighted {word}',},
                    { word: value[id].word },
                  )
                )
                if (!_.isEmpty(value[id].suggestions)) {
                  // label.push('Suggestions you can incorporate are ')
                  label.push(
                    this.props.intl.formatMessage({
                      id: 'aspire.sections.languageImpact.suggestionsIntro',
                      defaultMessage: 'Suggestions you can incorporate are ',
                    })
                  )
                  value[id].suggestions.forEach((element) => {
                    label.push(element)
                  })
                }
              }
            }
          }
        )
      } else {
        label.push(
          contentSectionAriaLabel(intl)[moduleSelected][currentSection]['green'][
            value
          ]
        )
      }
      ariaLabel[value] = label.join(', ')
    })
    return ariaLabel
  }

  getPresentationAriaLabel(
    feedback,
    params,
    currentIndex,
    currentSection,
    moduleSelected
  ) {
    const { intl } = this.props
    let ariaLabel = {}
    _.mapObject(params, (value, key) => {
      let label = []
      if (feedback[moduleSelected][value][currentIndex]['color'] != 'green') {
        label.push(
          contentSectionAriaLabel(intl)[moduleSelected][currentSection]['red'][value]
        )
        _.map(
          feedback[moduleSelected][value][currentIndex]['ids'],
          (value, key) => {
            for (let id = 0; id < value.length; id++) {
              if (label.indexOf(value[id].word) === -1) {
                // label.push(`Keyword highlighted ${value[id].word}`)
                label.push(
                  this.props.intl.formatMessage({
                    id: 'aspire.sections.languageImpact.keywordHighlighted',
                    defaultMessage: 'Keyword highlighted {word}',},
                    { word: value[id].word },
                  )
                )
                if (!_.isEmpty(value[id].suggestions)) {
                  // label.push('Suggestions you can incorporate are ')
                  label.push(
                    this.props.intl.formatMessage({
                      id: 'aspire.sections.languageImpact.suggestionsIntro',
                      defaultMessage: 'Suggestions you can incorporate are ',
                    })
                  )
                  value[id].suggestions.forEach((element) => {
                    label.push(element)
                  })
                }
              }
            }
          }
        )
      } else {
        label.push(
          contentSectionAriaLabel(intl)[moduleSelected][currentSection]['green'][
            value
          ]
        )
      }
      ariaLabel[value] = label.join(', ')
    })
    return ariaLabel
  }

  getLanguageImpactTabIndex() {
    let selectedMatched = false
    let selectedValue = this.state.selectedLanguageImpact
    for (var selected in this.tabIndexLanguageImpact) {
      if (selected == selectedValue) {
        selectedMatched = true
        this.tabIndexLanguageImpact[selected] = this.dynamicTabIndexing
      } else if (selectedMatched) {
        this.tabIndexLanguageImpact[selected] = this.dynamicTabIndexing + 1
      } else {
        this.tabIndexLanguageImpact[selected] = this.dynamicTabIndexing
      }
    }
  }

  getPresentationTabIndex() {
    let selectedMatched = false
    let selectedValue = this.state.selectedPresentation
    for (var selected in this.tabIndexPresentation) {
      if (selected == selectedValue) {
        selectedMatched = true
        this.tabIndexPresentation[selected] = this.dynamicTabIndexing
      } else if (selectedMatched) {
        this.tabIndexPresentation[selected] = this.dynamicTabIndexing + 1
      } else {
        this.tabIndexPresentation[selected] = this.dynamicTabIndexing
      }
    }
  }

  renderLanguageFeedback(feedback, currentSection, currentIndex) {
    const { intl } = this.props
    if (!this.renderModuleFeedback['language']) {
      return null
    }
    const { languageOpen } = this.state
    let params = ['buzzwords', 'verb_overusage', 'tense', 'narrative_voice']
    params = _.filter(params, function (value) {
      return (
        feedback['language'].hasOwnProperty(value) &&
        !_.isEmpty(feedback['language'][value]) &&
        feedback['language'][value].hasOwnProperty(currentIndex)
      )
    })
    let languageTabIndex = this.tabIndexLanguageImpact[params[0]]
    let ariaLabel = this.getLanguageImpactAriaLabel(
      feedback,
      params,
      currentIndex,
      currentSection,
      'language'
    )
    let borderclass = []

    if (params.length == 1) {
      if (!this.renderModuleFeedback['impact']) {
        borderclass.push('border-r-tl border-r-bl')
      } else {
        borderclass.push('border-r-bl')
      }
    } else {
      if (!this.renderModuleFeedback['impact']) {
        borderclass.push('border-r-tl')
      } else {
        borderclass.push('')
      }
      for (let i = 1; i < params.length - 1; i++) {
        borderclass.push('')
      }
      borderclass.push('border-r-bl')
    }
    let display = 'none'
    if (
      this.state.selectedModule === 'language' &&
      params.indexOf(this.state.selectedLanguageImpact) == -1
    ) {
      display = 'block'
    }
    params = _.map(params, (value, key) => (
      <div
        key={'tab-' + key}
        className={`tab section-language-tab section-language-tab-${feedback['language'][value][currentIndex]['color']}`}>
        <button
          tabIndex={this.tabIndexLanguageImpact[value]}
          aria-label={
            value == this.state.selectedLanguageImpact
              ? `${languageContent(intl)['title'][value]}, ${ariaLabel[value]}`
              : this.props.intl.formatMessage({
                  id: 'aspire.sections.languageFeedback.clickToKnow',
                  defaultMessage:
                    '{title}, Click to know about {value}',},
                  {
                    title: languageContent(intl)['title'][value],
                    value: value,
                  },
                )
          }
          className={classNames(borderclass[key], {
            active: value == this.state.selectedLanguageImpact,
          })}
          id={'tab-' + key}
          name="tab-group-1"
          data-value={value}
          data-module="language"
          onMouseOver={(e) => this.handleMouseOver(e)}
          onMouseOut={(e) => this.handleMouseOut(e)}
          onClick={() =>
            this.handleUpdateText(
              value,
              'language',
              feedback['language'][value][currentIndex],
              currentSection
            )
          }>
          <div className="section-language-tab-row">
            <img
              alt=""
              src={`${process.env.APP_BASE_URL}dist/images/${
                iconMap[feedback['language'][value][currentIndex]['color']]
              }`}
              className="feedback-parameter-icon"
              style={{ width: '17px', height: '17px' }}
            />
            {languageContent(intl)['title'][value]}
          </div>
        </button>
        <div
          className="content"
          style={{
            display:
              value == this.state.selectedLanguageImpact ? 'block' : display,
          }}>
          <p>
            <strong>
              {
                languageContent(intl)['content_section_score'][currentSection][
                  feedback['language'][value][currentIndex]['color']
                ][value]['title']
              }
            </strong>
          </p>
          <p>
            {
              languageContent(intl)['content_section_score'][currentSection][
                feedback['language'][value][currentIndex]['color']
              ][value]['text']
            }
          </p>
        </div>
      </div>
    ))

    if (_.isEmpty(params)) {
      return null
    }

    let pieScore = this.getModifiedScoreForPie(
      feedback,
      'language',
      currentIndex
    )
    let bodyText =
      feedbackContent(intl)[feedback['language']['score'][currentIndex]['color']][
        'body'
      ]['language']
    let bodyLabel =
      feedbackAriaLabel(intl)[feedback['language']['score'][currentIndex]['color']][
        'body'
      ]['language']

    if (feedback['language']['score'][currentIndex]['score'] > 99) {
      // bodyText = <p>You have no language gaps in this section.</p>
      // bodyLabel = 'You have no language gaps in this section.'
      bodyText = (
        <p>
          {this.props.intl.formatMessage({
            id: 'aspire.sections.languageFeedback.noGaps',
            defaultMessage: 'You have no language gaps in this section.',
          })}
        </p>
      )
      bodyLabel = this.props.intl.formatMessage({
        id: 'aspire.sections.languageFeedback.noGaps',
        defaultMessage: 'You have no language gaps in this section.',
      })
    }

    let remainingPieScore = 100 - parseFloat(pieScore)
    let greenColorCode = '#46a74d'
    let yellowColorCode = '#f89d2f'
    let redColorCode = '#ef4f3e'
    let selectedColorCode = null

    if (feedback['language']['score'][currentIndex]['color'] === 'red') {
      selectedColorCode = redColorCode
    } else if (
      feedback['language']['score'][currentIndex]['color'] === 'yellow'
    ) {
      selectedColorCode = yellowColorCode
    } else if (
      feedback['language']['score'][currentIndex]['color'] === 'green'
    ) {
      selectedColorCode = greenColorCode
    }

    let dataOptions = {
      datasets: [
        {
          data: [pieScore, remainingPieScore],
          backgroundColor: [selectedColorCode, '#E8E8E8'],
          borderColor: [selectedColorCode, '#E8E8E8'],
          borderWidth: 1,
        },
      ],
      labels: [],
    }

    let options = {
      maintainAspectRatio: false,
      animation: {
        animateRotate: true,
      },
      tooltips: {
        enabled: false,
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
      },
      responsive: false,
    }
    let infoOverlay = (
      <Popover id="popover-sub-section-info">
        {this.props.intl.formatMessage({
          id: 'aspire.sections.languageFeedback.infoOverlay',
          defaultMessage:
            'Check out the core elements on which your content is assessed.',
        })}
      </Popover>
    )

    return params
  }
  renderImpactZero(currentSection) {
    const { impactOpen } = this.state
    const { isGenAiFeedback } = this.props
    if (!['Summary', 'Experience'].includes(currentSection)) {
      return null
    }
    return (
      <div className='zero-impact-container'>
        <div
          className={`zero-impact-nav ${impactOpen && 'open'}`}
          onClick={() => this.toggleInfoBox('impact')}>
          <div className="zero-impact-nav-left">
            <p className="zero-impact-heading">
              {this.props.intl.formatMessage({
                id: 'aspire.sections.impactZero.heading',
                defaultMessage: 'Impact',
              })}
            </p>
            <img
              alt="info"
              className="info-img"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                this.showInfoModal('impact')
              }}
              src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
            />
            <img
              alt="score-bar"
              className="bar-img"
              src={`${process.env.APP_BASE_URL}dist/images/zero-impact-bar.png`}
            />
          </div>
          <div className="zero-impact-nav-right">
            <div className={`arrow arrow-${impactOpen ? 'bottom' : 'right'}`}></div>
          </div>
        </div>
        {impactOpen && (
          <div className="zero-impact-feedback">
            <div className="zero-impact-feedback-content">
              <div className="keys">
                <p>
                  {currentSection === 'Summary'
                    ? this.props.intl.formatMessage({
                        id: 'aspire.sections.impactZero.summaryKey1',
                        defaultMessage: 'Avoided Words',
                      })
                    : this.props.intl.formatMessage({
                        id: 'aspire.sections.impactZero.experienceKey1',
                        defaultMessage: 'Action Oriented',
                      })}
                </p>
                <div className="divide" />
                <p>
                  {currentSection === 'Summary'
                    ? this.props.intl.formatMessage({
                        id: 'aspire.sections.impactZero.summaryKey2',
                        defaultMessage: 'Overusage',
                      })
                    : this.props.intl.formatMessage({
                        id: 'aspire.sections.impactZero.experienceKey2',
                        defaultMessage: 'Specifics',
                      })}
                </p>
                <div className="divide" />
                <p>
                  {currentSection === 'Summary'
                    ? this.props.intl.formatMessage({
                        id: 'aspire.sections.impactZero.summaryKey3',
                        defaultMessage: 'Tense',
                      })
                    : this.props.intl.formatMessage({
                        id: 'aspire.sections.impactZero.experienceKey3',
                        defaultMessage: 'Avoided Words',
                      })}
                </p>
                <div className="divide" />
                <p>
                  {currentSection === 'Summary'
                    ? (!isGenAiFeedback ?
                      this.props.intl.formatMessage({
                          id: 'aspire.sections.impactZero.summaryKey4',
                          defaultMessage: 'Voice',
                      }) : null)
                    : this.props.intl.formatMessage({
                        id: 'aspire.sections.impactZero.experienceKey4',
                        defaultMessage: 'Overused',
                      })}
                </p>
                {currentSection === 'Experience' && (
                  <>
                    <div className="divide" />
                    <p>
                      {this.props.intl.formatMessage({
                        id: 'aspire.sections.impactZero.experienceKey5',
                        defaultMessage: 'Tense',
                      })}
                    </p>
                    {!isGenAiFeedback && (
                      <>
                        <div className="divide" />
                        <p>
                          {this.props.intl.formatMessage({
                            id: 'aspire.sections.impactZero.experienceKey6',
                            defaultMessage: 'Voice',
                          })}
                        </p>
                      </>
                    )}
                  </>
                )}
              </div>
              <div className="description">
                {currentSection === 'Summary'
                  ? this.props.intl.formatMessage({
                      id: 'aspire.sections.impactZero.summaryDescription',
                      defaultMessage:
                        'Please provide about to receive feedback on Impact elements.',
                    })
                  : this.props.intl.formatMessage({
                      id: 'aspire.sections.impactZero.experienceDescription',
                      defaultMessage:
                        'Please provide description to receive feedback on Impact elements.',
                    })}
              </div>
            </div>
            <div
              className="prams-know-more-desc"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                this.showInfoModal('impact')
              }}>
              {this.props.intl.formatMessage({
                id: 'aspire.sections.impactZero.knowMore',
                defaultMessage: 'Know more',
              })}{' '}
              <span className="icon icon-rightarrow" />
            </div>
          </div>
        )}
      </div>
    )
  }

  renderImpactFeedback(feedback, currentSection, currentIndex) {
    const { newSubSection, intl } = this.props
    if (
      (!this.renderModuleFeedback['impact'] &&
        !this.renderModuleFeedback['language']) ||
      newSubSection
    ) {
      return null
    }

    const { impactOpen } = this.state
    let impactParams
    let languageParams
    let paramsCount = 0
    let impactPieScore = 0
    let languagePieScore = 0

    let tabIndex = this.dynamicTabIndexing
    if (this.renderModuleFeedback['impact']) {
      let params = ['action_oriented', 'specifics']

      params = _.filter(params, function (value) {
        return feedback['impact'].hasOwnProperty(value)
      })
      let ariaLabel = this.getLanguageImpactAriaLabel(
        feedback,
        params,
        currentIndex,
        currentSection,
        'impact'
      )

      let borderclass = []

      if (params.length == 1) {
        borderclass.push('border-r-tl border-r-bl')
      } else {
        borderclass.push('border-r-tl')
        for (let i = 1; i < params.length - 1; i++) {
          borderclass.push('')
        }
        if (!this.renderModuleFeedback['language']) {
          borderclass.push('border-r-bl')
        } else {
          borderclass.push('')
        }
      }
      let display = 'none'
      if (
        this.state.selectedModule === 'impact' &&
        params.indexOf(this.state.selectedLanguageImpact) == -1
      ) {
        display = 'block'
      }

      impactParams = _.map(params, (value, key) => (
        <div
          key={'tab-impact-' + key}
          className={`tab section-impact-tab section-impact-tab-${feedback['impact'][value][currentIndex]['color']}`}>
          <button
            className={classNames(borderclass[key], {
              active: value == this.state.selectedLanguageImpact,
            })}
            id={'tab-impact-' + key}
            tabIndex={this.tabIndexLanguageImpact[value]}
            aria-label={
              value == this.state.selectedLanguageImpact
                ? `${impactContent(intl)['title'][value]} ${ariaLabel[value]}`
                : intl.formatMessage({
                    id: 'aspire.sections.impactFeedback.clickToKnow',
                    defaultMessage: '{title}, Click to know about {value}',},
                    {
                      title: impactContent(intl)['title'][value],
                      value: value,
                    },
                  )
            }
            name="tab-impact-group-1"
            data-value={value}
            data-module="impact"
            onMouseOver={(e) => this.handleMouseOver(e)}
            onMouseOut={(e) => this.handleMouseOut(e)}
            onClick={() =>
              this.handleUpdateText(
                value,
                'impact',
                feedback['impact'][value][currentIndex],
                currentSection
              )
            }>
            <div className="section-impact-tab-row">
              <img
                alt=""
                src={`${process.env.APP_BASE_URL}dist/images/${
                  iconMap[feedback['impact'][value][currentIndex]['color']]
                }`}
                className="feedback-parameter-icon"
                style={{ height: '17px', width: '17px' }}
              />
              {impactContent(intl)['title'][value]}
            </div>
          </button>
          <div
            className="content feedback-impact-content"
            style={{
              display:
                value == this.state.selectedLanguageImpact ? 'block' : display,
            }}>
            <p>
              <strong>
                {' '}
                {
                  impactContent(intl)['content_section_score'][currentSection][
                    feedback['impact'][value + '_color'][currentIndex]['color']
                  ][value]['title']
                }{' '}
              </strong>
            </p>
            <p>
              {
                impactContent(intl)['content_section_score'][currentSection][
                  feedback['impact'][value + '_color'][currentIndex]['color']
                ][value]['text']
              }
            </p>
          </div>
        </div>
      ))

      impactPieScore = this.getModifiedScoreForPie(
        feedback,
        'impact',
        currentIndex
      )
      paramsCount++
    }

    if (this.renderModuleFeedback['language']) {
      languageParams = this.renderLanguageFeedback(
        feedback,
        currentSection,
        currentIndex
      )
      languagePieScore = this.getModifiedScoreForPie(
        feedback,
        'language',
        currentIndex
      )
      paramsCount++
    }
    let pieScore = 0
    if (
      this.renderModuleFeedback['impact'] &&
      this.renderModuleFeedback['language']
    ) {
      pieScore = (impactPieScore + languagePieScore) / 2
    } else if (this.renderModuleFeedback['impact']) {
      pieScore = impactPieScore
    } else if (this.renderModuleFeedback['language']) {
      pieScore = languagePieScore
    }
    let impactLanguageColorClass = 'red'
    if (pieScore >= 70) {
      impactLanguageColorClass = 'green'
    } else if (pieScore >= 40 && pieScore < 70) {
      impactLanguageColorClass = 'yellow'
    }
    let remainingPieScore = 100 - parseFloat(pieScore)
    let infoOverlay = (
      <Popover id="popover-sub-section-info">
        {intl.formatMessage({
          id: 'aspire.sections.impactFeedback.infoOverlay',
          defaultMessage: 'Check the core elements on which your content is assessed.',
        })}
      </Popover>
    )

    return (
      <div key="impact" className="params-info-div">
        <div
          className={`params-info-header ${
            impactOpen ? '' : 'params-info-header-hide-bottom'
          } `}
          onClick={() => this.toggleInfoBox('impact')}>
          <div id="progress-bar-lable-imapct" className="g-text">
            <span>
              {intl.formatMessage({
                id: 'aspire.sections.impactFeedback.impact',
                defaultMessage: 'Impact',
              })}
            </span>
          </div>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            rootClose
            overlay={infoOverlay}>
            <div
              id="impact-as-info-text"
              aria-label="info"
              className="as-info-icon">
              <a
                role="button"
                tabIndex={tabIndex}
                aria-labelledby="impact-as-info-text"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  this.showInfoModal('impact')
                }}>
                <img
                  className="as-info-icon-img"
                  alt="info icon"
                  src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
                />
              </a>
            </div>
          </OverlayTrigger>
          <div className="param-progress-bar-graph">
            <div className="progress-bar-main">
              <div
                className={
                  'progress-bar progress-bar-' + impactLanguageColorClass
                }
                role="progressbar"
                aria-labelledby="progress-bar-lable-imapct"
                aria-valuenow={pieScore}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: pieScore + '%' }}>
                <span className="visually-hidden">
                  {intl.formatMessage({
                    id: 'aspire.sections.impactFeedback.srOnly',
                    defaultMessage: '40% Complete (success)',
                  })}
                </span>
              </div>
            </div>
          </div>
          {!(_.isEmpty(impactParams) && _.isEmpty(languageParams)) && (
            <div className="arrow-div">
              <div
                className={`arrow arrow-${
                  impactOpen ? 'bottom' : 'right'
                }`}></div>
            </div>
          )}
        </div>
        {!(_.isEmpty(impactParams) && _.isEmpty(languageParams)) && (
          <div
            className={`params-info-desc params-info-desc${
              impactOpen ? '-show' : '-hidden'
            }`}>
            <div className="tabs impact-tabs">
              {impactParams}
              {languageParams}
            </div>
            <div
              className="prams-know-more-desc"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                this.showInfoModal('impact')
              }}
            >
              {intl.formatMessage({
                id: 'aspire.sections.impactFeedback.knowMore',
                defaultMessage: 'Know more',
              })}{' '}
              <span className="icon icon-rightarrow" />
            </div>
          </div>
        )}
        <div className="clearfix" />
      </div>
    )
  }

  renderPresentationZero(currentSection) {
    const { presentationOpen } = this.state
    if (!['Heading', 'Summary', 'Experience', 'Education'].includes(currentSection)) {
      return null
    }
    return (
      <div className='zero-impact-container'>
        <div
          className={`zero-impact-nav ${presentationOpen && 'open'}`}
          onClick={() => this.toggleInfoBox('presentation')}>
          <div className="zero-impact-nav-left">
            <p className="zero-impact-heading">
              {this.props.intl.formatMessage({
                id: 'aspire.sections.presentationZero.heading',
                defaultMessage: 'Presentation',
              })}
            </p>
            <img
              alt="info"
              className="info-img"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                this.showInfoModal('presentation')
              }}
              src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
            />
            <img
              alt="score-bar"
              className="bar-img"
              src={`${process.env.APP_BASE_URL}dist/images/zero-impact-bar.png`}
            />
          </div>
          <div className="zero-impact-nav-right">
            <div className={`arrow arrow-${presentationOpen ? 'bottom' : 'right'}`}></div>
          </div>
        </div>
        {presentationOpen && (
          <div className="zero-impact-feedback">
            <div className="zero-impact-feedback-content">
              <div className="keys">
                {currentSection === 'Heading' ?
                    <p>
                        {this.props.intl.formatMessage({
                          id: 'aspire.sections.presentationZero.summaryKey1',
                          defaultMessage: 'Length',
                        })}
                    </p>
                  :
                  ['Summary', 'Experience'].includes(currentSection) ?
                    <>
                      <p>
                          {this.props.intl.formatMessage({
                            id: 'aspire.sections.presentationZero.summaryKey1',
                            defaultMessage: 'Length',
                          })}
                      </p>
                      <div className='divide' />
                      <p>
                          {this.props.intl.formatMessage({
                            id: 'aspire.sections.presentationZero.summaryKey2',
                            defaultMessage: 'Structure',
                          })}
                      </p>
                      <div className='divide' />
                      <p>
                          {this.props.intl.formatMessage({
                            id: 'aspire.sections.presentationZero.summaryKey3',
                            defaultMessage: 'Grammar',
                          })}
                      </p>
                    </>
                  :
                  currentSection === 'Education' ?
                    <>
                      <p>
                          {this.props.intl.formatMessage({
                            id: 'aspire.sections.presentationZero.summaryKey1',
                            defaultMessage: 'Length',
                          })}
                      </p>
                      <div className='divide' />
                      <p>
                          {this.props.intl.formatMessage({
                            id: 'aspire.sections.presentationZero.summaryKey2',
                            defaultMessage: 'Structure',
                          })}
                      </p>
                    </>
                  : null
                }
              </div>
              <div className="description">
                {currentSection === 'Summary'
                  ? this.props.intl.formatMessage({
                      id: 'aspire.sections.presentationZero.summaryDescription',
                      defaultMessage:
                        'Please provide summary to receive feedback on Presentation elements.',
                    })
                  : this.props.intl.formatMessage({
                      id: 'aspire.sections.presentationZero.experienceDescription',
                      defaultMessage:
                        'Please provide description to receive feedback on Presentation elements.',
                    })}
              </div>
            </div>
            <div
              className="prams-know-more-desc"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                this.showInfoModal('presentation')
              }}>
              {this.props.intl.formatMessage({
                id: 'aspire.sections.impactZero.knowMore',
                defaultMessage: 'Know more',
              })}{' '}
              <span className="icon icon-rightarrow" />
            </div>
          </div>
        )}
      </div>
    )
  }

  renderPresentationFeedback(feedback, currentSection, currentIndex) {
    const {newSubSection, intl, sectionWiseTextEditable, isUKEnable} = this.props
    if (
      (!this.renderModuleFeedback['presentation']) || newSubSection
    ) {
      return null
    }
    const { presentationOpen } = this.state
    let presentationParams
    let presentationParamsCount = 0
    let presentationPieScore = 0

    let tabIndex = this.dynamicTabIndexing
    if (this.renderModuleFeedback['presentation']) {
      let params = ['bullet_length', 'bullets_count', 'grammar']
      params = _.filter(params, function (value) {
        return feedback['presentation'].hasOwnProperty(value)
      })
      let ariaLabel = this.getPresentationAriaLabel(
        feedback,
        params,
        currentIndex,
        currentSection,
        'presentation'
      )
      let borderclass = []

      if (params.length == 1) {
        borderclass.push('border-r-tl border-r-bl')
      } else {
        borderclass.push('border-r-tl')
        for (let i = 1; i < params.length - 1; i++) {
          borderclass.push('')
        }
      }
      let display = 'none'
      if (
        this.state.selectedModule === 'presentation' &&
        params.indexOf(this.state.selectedPresentation) == -1
      ) {
        display = 'block'
      }

      const grammarWords = feedback?.presentation?.grammar?.[currentIndex]?.grammar;
      let grammarIdsObj = null
      if(grammarWords)
      {
        grammarIdsObj= this.buildGrammarIdsObj(grammarWords);
        grammarIdsObj.pos_present = true;
      }

      presentationParams = _.map(params, (value, key) => (
        <div
          key={'tab-presentation-' + key}
          className={`tab section-language-tab section-language-tab-${feedback['presentation'][value][currentIndex]['color']}`}>
          <button
            className={classNames(borderclass[key], {
              active: value == this.state.selectedPresentation,
            })}
            id={'tab-presentation-' + key}
            tabIndex={this.tabIndexPresentation[value]}
            aria-label={
              value == this.state.selectedPresentation
                ? `${presentationContent(intl, isUKEnable)['title'][value]} ${ariaLabel[value]}`
                : intl.formatMessage({
                    id: 'aspire.sections.impactFeedback.clickToKnow',
                    defaultMessage: '{title}, Click to know about {value}',},
                    {
                      title: presentationContent(intl, isUKEnable)['title'][value],
                      value: value,
                    },
                  )
            }
            name="tab-presentation-group-1"
            data-value={value}
            data-module="presentation"
            onMouseOver={(e) => this.handleMouseOver(e)}
            onMouseOut={(e) => this.handleMouseOut(e)}
            onClick={() => {
              this.handleUpdateText(
                value,
                'presentation',
                grammarIdsObj !== null && value==='grammar' ? grammarIdsObj : feedback['presentation'][value][currentIndex],
                currentSection
              )
            }}>
            <div className="section-language-tab-row">
              <img
                alt=""
                src={`${process.env.APP_BASE_URL}dist/images/${
                  iconMap[feedback['presentation'][value][currentIndex]['color']]
                }`}
                className="feedback-parameter-icon"
                style={{ width: '17px', height: '17px' }}
              />
              {presentationContent(intl, isUKEnable)['title'][value]}
            </div>
          </button>
          <div
            className="content feedback-impact-content"
            style={{
              display:
                value == this.state.selectedPresentation ? 'block' : display,
            }}>
            <p>
              <strong>
                {' '}
                {
                  presentationContent(intl, isUKEnable)['content_section_score'][currentSection][
                    feedback['presentation'][value + '_color'][currentIndex]['color']
                  ][value]['title']
                }{' '}
              </strong>
            </p>
            <p>
              {
                presentationContent(intl, isUKEnable)['content_section_score'][currentSection][
                  feedback['presentation'][value + '_color'][currentIndex]['color']
                ][value]['text']
              }
            </p>
          </div>
        </div>
      ))

      presentationPieScore = this.getModifiedScoreForPie(
        feedback,
        'presentation',
        currentIndex
      )
      presentationParamsCount++    
    }
    let pieScore = presentationPieScore
    let presentationColorClass = 'red'
    if (pieScore >= 70) {
      presentationColorClass = 'green'
    } else if (pieScore >= 40 && pieScore < 70) {
      presentationColorClass = 'yellow'
    }
    let remainingPieScore = 100 - parseFloat(pieScore)
    let infoOverlay = (
      <Popover id="popover-sub-section-info">
        {intl.formatMessage({
          id: 'aspire.sections.presentationFeedback.infoOverlay',
          defaultMessage: 'See how we assess clarity, structure, and writing quality.',
        })}
      </Popover>
    )
    return (
      <div key="presentation" className="params-info-div">
        <div
          className={`params-info-header ${
            presentationOpen ? '' : 'params-info-header-hide-bottom'
          } `}
          onClick={() => this.toggleInfoBox('presentation')}>
          <div id="progress-bar-lable-presentation" className="g-text">
            <span>
              {intl.formatMessage({
                id: 'aspire.sections.presentationFeedback.presentation',
                defaultMessage: 'Presentation',
              })}
            </span>
          </div>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            rootClose
            overlay={infoOverlay}>
            <div
              id="presentation-as-info-text"
              aria-label="info"
              className="as-info-icon">
              <a
                role="button"
                tabIndex={tabIndex}
                aria-labelledby="presentation-as-info-text"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  this.showInfoModal('presentation')
                }}>
                <img
                  className="as-info-icon-img"
                  alt="info icon"
                  src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
                />
              </a>
            </div>
          </OverlayTrigger>
          <div className="param-progress-bar-graph">
            <div className="progress-bar-main">
              <div
                className={
                  'progress-bar progress-bar-' + presentationColorClass
                }
                role="progressbar"
                aria-labelledby="progress-bar-lable-presentation"
                aria-valuenow={pieScore}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: pieScore + '%' }}>
                <span className="visually-hidden">
                  {intl.formatMessage({
                    id: 'aspire.sections.impactFeedback.srOnly',
                    defaultMessage: '40% Complete (success)',
                  })}
                </span>
              </div>
            </div>
          </div>
          {!(_.isEmpty(presentationParams)) && (
            <div className="arrow-div">
              <div
                className={`arrow arrow-${
                  presentationOpen ? 'bottom' : 'right'
                }`}></div>
            </div>
          )}
        </div>
        {!(_.isEmpty(presentationParams)) && (
          <div
            className={`params-info-desc params-info-desc${
              presentationOpen ? '-show' : '-hidden'
            }`}>
            <div className="tabs presentation-tabs">
              {presentationParams}
            </div>
            <div
              className="prams-know-more-desc"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                this.showInfoModal('presentation')
              }}
            >
              {intl.formatMessage({
                id: 'aspire.sections.impactFeedback.knowMore',
                defaultMessage: 'Know more',
              })}{' '}
              <span className="icon icon-rightarrow" />
            </div>
          </div>
        )}
        <div className="clearfix" />
      </div>
    )
  }

  getCategoryAriaLabel(categoriesFeedback) {
    var categoryLabelMap = {}
    _.mapObject(categoriesFeedback, (value, key) => {
      let label = []
      let endText = ` are detected as ${key}`
      _.map(value['ids'], (value, key) => {
        for (let id = 0; id < value.length; id++) {
          if (label.indexOf(value[id].word) === -1) {
            label.push(value[id].word)
          }
        }
      })
      label.push(endText)
      categoryLabelMap[key] = label.join(', ')
    })
    return categoryLabelMap
  }

  toggleInfoBox(category) {
    let obj = {}
    obj[category + 'Open'] = !this.state[category + 'Open']
    this.setState(obj)
  }

  renderNewSuggestedCategories(currentSection) {
    const { newSubSection, currentTab, intl } = this.props
    const { informationCategoryOpen } = this.state
    let catMissing = []
    if (newSubSection) {
      catMissing = [
        'Company/Organisation',
        'Degree',
        'School/University',
        'Certifications',
        'Concentration',
        'Position of Responsibility',
        'Club/Society',
        'Competitions',
        'Awards',
        'Goal Based Keyword',
      ]
      catMissing = catMissing.map((item) => this.getCategoryName(this.keyConversion(item), intl))
    }

    let categoriesAbsent = []
    let categoriesAbsentBlock = null

    if (!_.isUndefined(catMissing)) {
      for (let i in catMissing) {
        categoriesAbsent.push(
          <li key={i}>
            <a
              tabIndex={currentTab + 1}
              aria-label={catMissing[i]}
              onClick={() =>
                this.handleGrayCategoriesTracking(
                  'content',
                  'categories',
                  catMissing[i]
                )
              }
              role="button">
              {' '}
              {catMissing[i]}{' '}
            </a>
          </li>
        )
      }

      if (!_.isEmpty(categoriesAbsent)) {
        categoriesAbsentBlock = (
          <div>
            <div className="keyword-heading">
              <span>
                <span>{divisionSubHeadlineText(intl)['categories']['missing']}</span>
              </span>
            </div>
            <div className="keyword-suggestion">
              {editModalAriaLabel(intl)[currentSection]['content_try']}
            </div>
            <ul className="tab-keywords keywords-gray">{categoriesAbsent}</ul>
          </div>
        )
      }
    }

    let showDescBlock = !_.isNull(categoriesAbsentBlock)
    let infoOverlay = (
      <Popover id="popover-sub-section-info">
        {intl.formatMessage({
          id: 'aspire.sections.newSuggestedCategories.infoOverlay',
          defaultMessage: 'Check how to illustrate information in {currentSection}',},
          { currentSection: currentSection === 'Summary' ? intl.formatMessage({id : "aspire.summary.heading" }) : intl.formatMessage({id : sectionNameMap[currentSection],}) },
        )}
      </Popover>
    )

    return (
      <div className="params-info-div">
        <div
          className={`params-info-header ${
            informationCategoryOpen ? '' : 'params-info-header-hide-bottom'
          } `}
          onClick={() => this.toggleInfoBox('informationCategory')}>
          <div id="progress-bar-lable-impact" className="g-text">
            <span>
              {intl.formatMessage({
                id: 'aspire.sections.newSuggestedCategories.informationCategories',
                defaultMessage: 'Information Categories',
              })}
            </span>
          </div>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            rootClose
            overlay={infoOverlay}>
            <div className="as-info-icon" aria-label="Info">
              <a
                role="button"
                tabIndex={currentTab}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  this.showInfoModal('categories')
                }}>
                <img
                  className="as-info-icon-img"
                  alt="info icon"
                  src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
                />
              </a>
            </div>
          </OverlayTrigger>
          {showDescBlock && (
            <div className="arrow-div">
              <div
                className={`arrow arrow-${
                  informationCategoryOpen ? 'bottom' : 'right'
                }`}></div>
            </div>
          )}
        </div>
        {showDescBlock && (
          <div
            className={`params-info-desc params-info-desc${
              informationCategoryOpen ? '-show' : '-hidden'
            }`}
            style={{ minHeight: 'unset' }}
          >
            {categoriesAbsentBlock}
            <div
              className="prams-know-more-desc"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                this.showInfoModal('categories')
              }}>
              {intl.formatMessage({
                id: 'aspire.sections.newSuggestedCategories.knowMore',
                defaultMessage: 'Know more',
              })}{' '}
              <span className="icon icon-rightarrow" />
            </div>
          </div>
        )}
      </div>
    )
  }

  keyConversion(word) {
    const specialCases = {
      'Job Role': 'jobRole',
      'Club/Society': 'clubSociety',
      'Industry': 'industry',
      'Degree': 'degree',
      'Concentration': 'concentration',
      'Job Function': 'jobFunction',
      'School/University': 'schoolUniversity',
      'Certifications': 'certifications',
      'Goal Based Keyword': 'goalBasedKeyword',
      'Company/Organization': 'company',
      'Company/Organisation': 'company',
      'Position of Responsibility': 'positionOfResponsibility',
      'Competitions': 'competitions',
      'Awards': 'awards'
    };
    if (specialCases[word]) {
      return specialCases[word];
    }
    else return word
  }

  getCategoryName(key, intl) {
    return intl.formatMessage({
      id: `aspire.category.${key}`,
      defaultMessage: key
    });
  }

  renderCategoriesFeedback(feedback, currentSection, currentIndex, tabIndex) {
    const { user, intl } = this.props
    const { informationCategoryOpen } = this.state
    if (!this.renderModuleFeedback['categories']) {
      return null
    }
    let firstActiveKey = this.state.selectedValue
    let green = null
    let categoriesPresent = []

    if (
      feedback['categories'].hasOwnProperty('categories') &&
      !_.isEmpty(feedback['categories']['categories'][currentIndex])
    ) {
      let keyTabIndex = {}
      let selectedMatched = false
      _.map(
        feedback['categories']['categories'][currentIndex],
        (value, key) => {
          if (key == this.state.selectedValue) {
            keyTabIndex[key] = tabIndex
            selectedMatched = true
            this.dynamicTabIndexing = 12
          } else if (!selectedMatched) {
            keyTabIndex[key] = tabIndex
          } else {
            keyTabIndex[key] = 12
          }
        }
      )
      if (!selectedMatched) {
        this.dynamicTabIndexing = 11
      }
      categoriesPresent = _.map(
        feedback['categories']['categories'][currentIndex],
        (value, key) => (
          <li
            key={key}
            className={this.state.selectedValue === key ? 'active' : ''}>
            <a
              tabIndex={keyTabIndex[key]}
              aria-label={
                this.state.selectedValue === key
                  ? intl.formatMessage({
                      id: "aspire.sections.categoriesFeedback.tabToKnow",
                      defaultMessage: "{category}. Tab to know where you have used",},
                      { category: key }
                    )
                  : intl.formatMessage({
                      id: "aspire.sections.categoriesFeedback.clickToKnow",
                      defaultMessage: "{category}. Click to know where you have used",},
                      { category: key }
                    )
              }
              data-value={key}
              data-module="categories"
              role="button"
              onClick={() =>
                this.handleUpdateText(key, 'categories', value, currentSection)
              }>
              {this.getCategoryName(this.keyConversion(key), intl)}
            </a>
          </li>
        )
      )

      if (!_.isEmpty(categoriesPresent)) {
        green = (
          <div>
            <div className="keyword-heading">
              <span>{divisionSubHeadlineText(intl)['categories']['present']}</span>
            </div>
            <ul className="tab-keywords keywords-green">{categoriesPresent}</ul>
          </div>
        )
      }
    }

    let categoriesMissing = []
    let catMissing = []
    if (
      feedback.hasOwnProperty('categories_missing') &&
      Array.isArray(feedback['categories_missing']) &&
      feedback['categories_missing'][currentIndex] &&
      Array.isArray(feedback['categories_missing'][currentIndex]) &&
      feedback['categories_missing'][currentIndex].length > 0
    ) {
      categoriesMissing = feedback['categories_missing']
      catMissing = categoriesMissing[currentIndex]
      catMissing = catMissing.map((item) => this.getCategoryName(this.keyConversion(item), intl))
    }
    let categoriesAbsent = []
    let categoriesAbsentBlock = null
    if (
      minRelevantCategories.hasOwnProperty(currentSection) &&
      _.size(categoriesPresent) >= minRelevantCategories[currentSection]
    ) {
      catMissing = []
    }

    if (!_.isUndefined(catMissing)) {
      for (let i in catMissing) {
        categoriesAbsent.push(
          <li key={i}>
            <a
              tabIndex={tabIndex + 1}
              aria-label={catMissing[i]}
              onClick={() =>
                this.handleGrayCategoriesTracking(
                  'content',
                  'categories',
                  catMissing[i]
                )
              }
              role="button">
              {' '}
              {catMissing[i]}{' '}
            </a>
          </li>
        )
      }

      if (!_.isEmpty(categoriesAbsent)) {
        categoriesAbsentBlock = (
          <div>
            <div className="keyword-heading">
              <span>
                <span>{divisionSubHeadlineText(intl)['categories']['missing']}</span>
              </span>
            </div>
            <div className="keyword-suggestion">
              {editModalAriaLabel(intl)[currentSection]['content_try']}
            </div>
            <ul className="tab-keywords keywords-gray">{categoriesAbsent}</ul>
          </div>
        )
      }
    }

    let resumeCategories = []
    if (feedback.hasOwnProperty('categories_in_resume_not_in_linkedin')) {
      resumeCategories = feedback['categories_in_resume_not_in_linkedin']
    }

    let categoriesInResumeNotInLinkedin = []
    let categoriesInResumeNotInLinkedinBlock = null
    if (
      !_.isUndefined(resumeCategories) ||
      !_.isEmpty(resumeCategories) ||
      !_.isUndefined(resumeCategories[currentIndex])
    ) {
      for (let i in resumeCategories[currentIndex]) {
        categoriesInResumeNotInLinkedin.push(
          <li key={i}>
            <a
              role="button"
              tabIndex={tabIndex + 1}
              aria-label={resumeCategories[currentIndex][i]}
              onClick={() =>
                this.handleResumeCategoriesTracking(
                  'content',
                  'categories',
                  resumeCategories[currentIndex][i]
                )
              }>
              {resumeCategories[currentIndex][i]}
            </a>
          </li>
        )
      }

      if (!_.isEmpty(categoriesInResumeNotInLinkedin)) {
        let resumeKey = user && user.isResumeCalledCv ? 'cv' : 'resume'
        categoriesInResumeNotInLinkedinBlock = (
          <div>
            <div className="keyword-heading">
              <span>
                <span>{divisionSubHeadlineText(intl)['categories'][resumeKey]} </span>
              </span>
            </div>
            <ul className="tab-keywords keywords-blue">
              {categoriesInResumeNotInLinkedin}
            </ul>
          </div>
        )
      }
    }

    let pieScore = this.getModifiedScoreForPie(
      feedback,
      'categories',
      currentIndex
    )
    let remainingPieScore = 100 - parseFloat(pieScore)
    let greenColorCode = '#46a74d'
    let yellowColorCode = '#f89d2f'
    let redColorCode = '#ef4f3e'
    let selectedColorCode = null

    if (feedback['categories']['score'][currentIndex]['color'] === 'red') {
      selectedColorCode = redColorCode
    } else if (
      feedback['categories']['score'][currentIndex]['color'] === 'yellow'
    ) {
      selectedColorCode = yellowColorCode
    } else if (
      feedback['categories']['score'][currentIndex]['color'] === 'green'
    ) {
      selectedColorCode = greenColorCode
    }

    let dataOptions = {
      datasets: [
        {
          data: [pieScore, remainingPieScore],
          backgroundColor: [selectedColorCode, '#E8E8E8'],
          borderColor: [selectedColorCode, '#E8E8E8'],
          borderWidth: 1,
        },
      ],
    }

    let options = {
      maintainAspectRatio: false,
      animation: {
        animateRotate: true,
      },
      tooltips: {
        enabled: false,
      },
      responsive: false,
    }

    if (feedback['categories']['score'][currentIndex]['color'] == 'green') {
      categoriesInResumeNotInLinkedinBlock = null
      categoriesAbsentBlock = null
    }

    let showDescBlock =
      !_.isNull(green) ||
      !_.isNull(categoriesInResumeNotInLinkedinBlock) ||
      !_.isNull(categoriesAbsentBlock)
    let infoOverlay = (
      <Popover id="popover-sub-section-info">
        {intl.formatMessage({
          id: "aspire.sections.categoriesFeedback.checkHowToIllustrate",
          defaultMessage: "Check how to illustrate information in {currentSection}",},
          { currentSection: currentSection === 'Summary' ? intl.formatMessage({id : "aspire.summary.heading" }) : intl.formatMessage({id : sectionNameMap[currentSection]}) }
        )}
      </Popover>
    )

    return (
      <div className="params-info-div">
        <div
          className={`params-info-header ${
            informationCategoryOpen ? '' : 'params-info-header-hide-bottom'
          } `}
          onClick={() => this.toggleInfoBox('informationCategory')}>
          <div id="progress-bar-lable-impact" className="g-text">
            <span>
              {intl.formatMessage({
                id: "aspire.sections.categoriesFeedback.informationCategories",
                defaultMessage: "Information Categories"
              })}
            </span>
          </div>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            rootClose
            overlay={infoOverlay}>
            <div className="as-info-icon" aria-label="Info">
              <a
                role="button"
                tabIndex={tabIndex}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  this.showInfoModal('categories')
                }}>
                <img
                  className="as-info-icon-img"
                  alt="info icon"
                  src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
                />
              </a>
            </div>
          </OverlayTrigger>
          <div className="param-progress-bar-graph">
            <div className="progress-bar-main">
              <div
                className={
                  'progress-bar progress-bar-' +
                  feedback['categories']['score'][currentIndex]['color']
                }
                role="progressbar"
                aria-labelledby="progress-bar-lable-impact"
                aria-valuenow={pieScore}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: pieScore + '%' }}>
                <span className="visually-hidden">
                  {intl.formatMessage({
                    id: "aspire.sections.categoriesFeedback.complete",
                    defaultMessage: "{percent}% Complete (success)",},
                    { percent: 40 }
                  )}
                </span>
              </div>
            </div>
          </div>
          {showDescBlock && (
            <div className="arrow-div">
              <div
                className={`arrow arrow-${
                  informationCategoryOpen ? 'bottom' : 'right'
                }`}></div>
            </div>
          )}
        </div>
        {showDescBlock && (
          <div
            className={`params-info-desc params-info-desc${
              informationCategoryOpen ? '-show' : '-hidden'
            }`}
            style={{ minHeight: 'unset' }}
          >
            {categoriesAbsentBlock}
            {categoriesInResumeNotInLinkedinBlock}
            {green}
            <div
              className="prams-know-more-desc"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                this.showInfoModal('categories')
              }}>
              {intl.formatMessage({
                id: "aspire.sections.categoriesFeedback.knowMore",
                defaultMessage: "Know more"
              })}{' '}
              <span className="icon icon-rightarrow" />
            </div>
          </div>
        )}
      </div>
    )
  }

  handleResumeSkillClick(index, skill, type) {
    const { ui, currentSection } = this.props
    let currentIndex = ui.currentIndex
    let jsonObjectForTracking = {
      eventLabel: 'skills_guide_resume_skill_click',
      currentSection: currentSection,
      currentIndex: currentIndex,
      module: 'skills',
      skill: skill,
      type: type,
    }
    this.trackResumeSkills(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    this.setState({ skillsResumeIndex: index })
  }

  missingAndResumeSkillsProcessingLogic(relMissSkills = []) {
    const {
      currentSection,
      newSubSection,
      sectionsPerSkill,
      resumeSkillsInLinkedin,
      feedback,
      ui,
    } = this.props

    let data = feedback['skills']
    const currentIndex = ui.currentIndex

    this.resumeSkills = []
    this.missingSkills = []

    if (!_.isEmpty(relMissSkills)) {
      let possessedSkills = {}
      // First prioritize hard skills by score, then soft skills by score
      let otherSkills = {
        hard_skills: {
          1: [],
          0.9: [],
          0.8: [],
          0.7: [],
          0.6: [],
          0.5: [],
        },
        sub_competency: {
          1: [],
          0.9: [],
          0.8: [],
          0.7: [],
          0.6: [],
          0.5: [],
        },
      }
      for (let i in relMissSkills) {
        let otherSections = {}
        let phrases = []
        let skill = relMissSkills[i]['word']
        if (sectionsPerSkill.hasOwnProperty(skill)) {
          phrases = sectionsPerSkill[skill]['phrases']
          for (let sec in sectionsPerSkill[skill]['sections']) {
            for (let secIndex in sectionsPerSkill[skill]['sections'][sec]) {
              if (sec != currentSection || secIndex != currentIndex) {
                let ind = parseInt(secIndex)
                let otherSectionName = ''
                if ((ind == 0) & (sec != currentSection)) {
                  otherSectionName = sec
                } else {
                  ind += 1
                  otherSectionName = sec + ' ' + ind
                }

                let states = { stated: false, derived: false }
                for (let k in sectionsPerSkill[skill]['sections'][sec][
                  secIndex
                ]) {
                  states[
                    sectionsPerSkill[skill]['sections'][sec][secIndex][k][
                      'state'
                    ]
                  ] = true
                }
                otherSections[otherSectionName] = states
              }
            }
          }
        }
        if (!_.isEmpty(phrases) || !_.isEmpty(otherSections)) {
          possessedSkills[skill] = {
            phrases: phrases,
            other_sections: otherSections,
            type: relMissSkills[i]['type'],
          }
        } else if (
          otherSkills[relMissSkills[i]['type']].hasOwnProperty(
            relMissSkills[i]['score']
          )
        ) {
          otherSkills[relMissSkills[i]['type']][relMissSkills[i]['score']].push(
            skill
          )
        }
      }

      let count = 0
      let skillsLimit = 10
      if (currentSection == 'Headline') {
        skillsLimit = 5
      }

      for (let skill in possessedSkills) {
        let isResumeSkill = _.contains(
          resumeSkillsInLinkedin,
          skill.toLowerCase()
        )
        if (isResumeSkill) {
          this.resumeSkills.push(skill)
        } else {
          this.missingSkills.push(skill)
        }
        count += 1
        if (count == skillsLimit) {
          break
        }
      }

      for (let typeVar in otherSkills) {
        if (count == skillsLimit) {
          break
        }
        for (let score in otherSkills[typeVar]) {
          if (count == skillsLimit) {
            break
          }
          for (let k in otherSkills[typeVar][score]) {
            if (count == skillsLimit) {
              break
            }
            let skill = otherSkills[typeVar][score][k]
            let isResumeSkill = _.contains(
              resumeSkillsInLinkedin,
              skill.toLowerCase()
            )

            if (isResumeSkill) {
              this.resumeSkills.push(skill)
            } else {
              this.missingSkills.push(skill)
            }
            count += 1
          }
        }
      }
    }
  }

  getResumeSkills() {
    const {
      dataSkills,
      dataResumeGaps = null,
      currentSection,
      feedback,
      newSubSection,
      sectionsPerSkill,
      resumeSkillsInLinkedin,
      normalResume,
      ui,
      intl,
    } = this.props
    const { skillsResumeOpen } = this.state
    if (_.isNull(dataResumeGaps)) {
      return null
    }
    let data = feedback['skills']
    const currentIndex = ui.currentIndex
    let relMissSkills = []
    if (
      newSubSection === false &&
      data.hasOwnProperty('relevant_skills_missing') &&
      data['relevant_skills_missing'].hasOwnProperty(currentIndex)
    ) {
      relMissSkills = [].concat(data['relevant_skills_missing'][currentIndex])
    } else if (
      newSubSection === true &&
      currentSection == 'Experience' &&
      data.hasOwnProperty('recommended_skills') &&
      data['recommended_skills'].hasOwnProperty(0)
    ) {
      relMissSkills = [].concat(data['recommended_skills'][0])
    } else if (
      currentSection == 'Summary' &&
      data.hasOwnProperty('relevant_skills_missing') &&
      data['relevant_skills_missing'].hasOwnProperty(0)
    ) {
      relMissSkills = [].concat(data['relevant_skills_missing'][0])
    }
    this.missingAndResumeSkillsProcessingLogic(relMissSkills)

    this.resumeSkills = _.filter(this.resumeSkills, function (resumeSkill) {
      if (
        dataResumeGaps.hasOwnProperty('skills') &&
        dataResumeGaps['skills'].hasOwnProperty('hard_skills') &&
        dataResumeGaps['skills']['hard_skills'].hasOwnProperty(resumeSkill)
      ) {
        return true
      } else if (
        dataResumeGaps.hasOwnProperty('skills') &&
        dataResumeGaps['skills'].hasOwnProperty('sub_competency') &&
        dataResumeGaps['skills']['sub_competency'].hasOwnProperty(resumeSkill)
      ) {
        return true
      }
      return false
    })

    let len = 0
    this.sectionSamples = []

    let noOfResumeSkills = _.size(this.resumeSkills)
    this.showMoreResumeSkills = false
    if (noOfResumeSkills > 0) {
      let skillsLimit = 5
      if (noOfResumeSkills > skillsLimit) {
        this.showMoreResumeSkills = true
        if (this.state.resumeSkillsState == 'collapsed') {
          let i = 0
          this.resumeSkills = _.filter(this.resumeSkills, function (skill) {
            i++
            if (i <= skillsLimit) {
              return true
            } else {
              return false
            }
          })
        }
      }

      this.sectionSamples = _.map(this.resumeSkills, function (resumeSkill) {
        if (
          dataResumeGaps.hasOwnProperty('skills') &&
          dataResumeGaps['skills'].hasOwnProperty('hard_skills') &&
          dataResumeGaps['skills']['hard_skills'].hasOwnProperty(resumeSkill)
        ) {
          return {
            name: resumeSkill,
            example: dataResumeGaps['skills']['hard_skills'][resumeSkill],
          }
        } else if (
          dataResumeGaps.hasOwnProperty('skills') &&
          dataResumeGaps['skills'].hasOwnProperty('sub_competency') &&
          dataResumeGaps['skills']['sub_competency'].hasOwnProperty(resumeSkill)
        ) {
          return {
            name: resumeSkill,
            example: dataResumeGaps['skills']['sub_competency'][resumeSkill],
          }
        }
      })

      len = _.size(this.sectionSamples)
      let selectedIndex =
        this.state.skillsResumeIndex > len - 1
          ? 0
          : this.state.skillsResumeIndex
      if (this.state.skillsResumeIndex > len - 1) {
        this.setState({
          skillsResumeIndex: 0,
        })
      }
      let skillsList = []
      for (let i = 0; i < len; i++) {
        let isSelected = false
        if (selectedIndex == i) {
          isSelected = true
        }
        let skill = this.sectionSamples[i]['name']

        let type = null
        skillsList.push(
          <button
            key={skill}
            onClick={() => this.handleResumeSkillClick(i, skill, type)}
            tabIndex={
              !this.showMoreResumeSkills
                ? 0
                : this.state.resumeSkillsState == 'collapsed'
                ? -1
                : 0
            }
            aria-label={skill}
            className={classNames('keywords-grey-resume-skills', {
              active: isSelected,
            })}>
            {skill}
          </button>
        )
      }

      let exampleBullets = []
      exampleBullets = _.map(
        this.sectionSamples[selectedIndex]['example'],
        function (example, key) {
          return (
            <div key={key} tabIndex={0} aria-label={example}>
              {example}
            </div>
          )
        }
      )

      return (
        <div className="params-info-div params-info-div-resume-skills">
          <div
            className={`params-info-header params-info-header-resume-skills ${
              skillsResumeOpen ? '' : 'params-info-header-hide-bottom'
            } `}
            onClick={() => this.toggleInfoBox('skillsResume')}>
            <div
              className="g-text"
              aria-label={
                editModalAriaLabel(intl, this.props.user && this.props.user.isResumeCalledCv)[currentSection]['mentioned_skill_resume']
              }>
              <span>
                {intl.formatMessage({
                  id: "aspire.sections.getResumeSkills.checkSkillsInclusion",
                  defaultMessage: "Check Skills Inclusion in Your {resumeType}",},
                  { resumeType: normalResume }
                )}
              </span>
            </div>
            <div className="arrow-div">
              <div
                className={`arrow arrow-${
                  skillsResumeOpen ? 'bottom' : 'right'
                }`}></div>
            </div>
          </div>
          <div
            className={`params-info-desc params-info-desc${
              skillsResumeOpen ? '-show' : '-hidden'
            }`}
            style={{ minHeight: 'unset' }}
          >
            {skillsList}
            <div className="keywords-resume-skills-text">{exampleBullets}</div>
          </div>
        </div>
      )
    }

    return null
  }

  renderNewSuggestedSkills(currentSection, currentIndex, tabIndex) {
    if (currentSection === 'Education') {
      return null
    }

    const { newSubSection, newSectionSuggestedSkills, intl } = this.props
    const { skillInclusionOpen } = this.state
    let skillsMissingOtherBlock = null

    let suggestedSkillsOther = []
    if (
      !_.isUndefined(newSectionSuggestedSkills) &&
      newSectionSuggestedSkills.length > 0
    ) {
      suggestedSkillsOther = _.map(newSectionSuggestedSkills, (value, key) => (
        <li key={value + currentSection + currentIndex + 'suggested'}>
          <a
            role="button"
            tabIndex={12}
            aria-label={value}
            onClick={() =>
              this.handleOtherSkillsTracking('skills', 'skills', value)
            }>
            {' '}
            {this.toTitleCase(value)}{' '}
          </a>
        </li>
      ))
    }

    if (!_.isEmpty(suggestedSkillsOther)) {
      skillsMissingOtherBlock = (
        <div>
          <div className="keyword-heading">
            <span>
              <span>{divisionSubHeadlineText(intl)['skills']['missing']}</span>
            </span>
          </div>
          <div className="keyword-suggestion">
            {editModalAriaLabel(intl)[currentSection]['skill_try']}
          </div>
          <ul className="tab-keywords keywords-gray">{suggestedSkillsOther}</ul>
        </div>
      )
    } else {
      skillsMissingOtherBlock = (
        <div>
          <div className="keyword-heading">
            <span>
              <span>{divisionSubHeadlineText(intl)['skills']['missing']}</span>
            </span>
          </div>
          <div className="keyword-suggestion">
            {editModalAriaLabel(intl)[currentSection]['skill_try']}
          </div>
          <div className="keyword-suggestion-static">
            {intl.formatMessage({
              id: "aspire.sections.getResumeSkills.addSkillsRelevant",
              defaultMessage:
                "Add skills relevant to your targeted job and increase your exposure to recruiters, establish your credibility, facilitate networking, and contribute to your overall personal branding."
            })}
          </div>
        </div>
      )
    }

    let infoOverlay = (
      <Popover id="popover-sub-section-info">
        {intl.formatMessage({
          id: "aspire.sections.getResumeSkills.checkHowToDemonstrate",
          defaultMessage: "Check how to demonstrate skills in your LinkedIn profile."
        })}
      </Popover>
    )
    return (
      <div className="params-info-div">
        <div
          className={`params-info-header ${
            skillInclusionOpen ? '' : 'params-info-header-hide-bottom'
          } `}
          onClick={() => this.toggleInfoBox('skillInclusion')}>
          <div id="progress-bar-lable-skill" className="g-text">
            <span>
              {intl.formatMessage({
                id: "aspire.sections.getResumeSkills.skillInclusion",
                defaultMessage: "Skill Inclusion"
              })}
            </span>
          </div>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            rootClose
            overlay={infoOverlay}>
            <div className="as-info-icon">
              <a
                role="button"
                tabIndex={tabIndex}
                aria-label={infoScreenConnectLabel(intl)['skills']}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  this.showInfoModal('skills')
                }}>
                <img
                  className="as-info-icon-img"
                  alt="info icon"
                  src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
                />
              </a>
            </div>
          </OverlayTrigger>
          <div className="arrow-div">
            <div
              className={`arrow arrow-${
                skillInclusionOpen ? 'bottom' : 'right'
              }`}></div>
          </div>
        </div>
        <div
          className={`params-info-desc params-info-desc${
            skillInclusionOpen ? '-show' : '-hidden'
          }`}
          style={{ minHeight: 'unset' }}
        >
          {skillsMissingOtherBlock}
          <div
            className="prams-know-more-desc"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              this.showInfoModal('skills')
            }}>
            {intl.formatMessage({
              id: "aspire.sections.getResumeSkills.clickToKnowMore",
              defaultMessage: "Know more"
            })}{' '}
            <span className="icon icon-rightarrow" />
          </div>
        </div>
      </div>
    )
  }

  renderSkillsFeedback(
    feedback,
    sectionsPerSkill,
    currentSection,
    currentIndex,
    resumeSkillsInLinkedin,
    resumeSkillsNotInLinkedin,
    suggestedSkills,
    derivedSkills,
    tabIndex
  ) {
    if (!this.renderModuleFeedback['skills']) {
      return null
    }
    const { user, intl } = this.props
    const { skillInclusionOpen } = this.state
    let data = feedback['skills']
    let skillsPresentBlock = []
    let skillsPresent = []
    let skillsLimit = 10
    if (
      data.hasOwnProperty('relevant_skills_present') &&
      data['relevant_skills_present'].hasOwnProperty(currentIndex)
    ) {
      let prioritizeSkills = {
        hard_skills: {
          1: [],
          0.9: [],
          0.8: [],
          0.7: [],
          0.6: [],
          0.5: [],
        },
        sub_competency: {
          1: [],
          0.9: [],
          0.8: [],
          0.7: [],
          0.6: [],
          0.5: [],
        },
      }
      for (var skill in data['relevant_skills_present'][currentIndex]) {
        for (var k in data['relevant_skills_present'][currentIndex][skill]) {
          if (
            prioritizeSkills[
              data['relevant_skills_present'][currentIndex][skill][k]['type']
            ].hasOwnProperty(
              data['relevant_skills_present'][currentIndex][skill][k]['score']
            )
          ) {
            prioritizeSkills[
              data['relevant_skills_present'][currentIndex][skill][k]['type']
            ][
              data['relevant_skills_present'][currentIndex][skill][k]['score']
            ].push(skill)
          }
        }
      }

      let greenKeywords = []
      let count = 0
      for (let typeVar in prioritizeSkills) {
        if (count == skillsLimit) {
          break
        }
        for (let score in prioritizeSkills[typeVar]) {
          if (count == skillsLimit) {
            break
          }
          let uniq = _.uniq(prioritizeSkills[typeVar][score])
          for (let k in uniq) {
            if (count == skillsLimit) {
              break
            }
            let skill = uniq[k]
            greenKeywords.push({ type: typeVar, skill: skill })
            count += 1
          }
        }
      }

      for (let skillIndex in greenKeywords) {
        var skill = greenKeywords[skillIndex]['skill']
        let skillType = greenKeywords[skillIndex]['type']
        let flag = true
        if (currentSection == 'Headline') {
          flag = false
          for (let k in data['relevant_skills_present'][currentIndex][skill]) {
            if (
              data['relevant_skills_present'][currentIndex][skill][k][
                'state'
              ] == 'stated'
            ) {
              flag = true
              break
            }
          }
        }

        if (flag === false) {
          continue
        }

        let otherSections = {}
        let phrases = []
        let sectionStates = { stated: false, derived: false }
        if (sectionsPerSkill.hasOwnProperty(skill)) {
          phrases = sectionsPerSkill[skill]['phrases']
          for (let sec in sectionsPerSkill[skill]['sections']) {
            for (let secIndex in sectionsPerSkill[skill]['sections'][sec]) {
              if (sec != currentSection || secIndex != currentIndex) {
                let ind = parseInt(secIndex)
                let otherSectionName = ''
                if (ind == 0 && sec != currentSection) {
                  otherSectionName = sec
                } else {
                  ind += 1
                  otherSectionName = sec + ' ' + ind
                }

                let states = { stated: false, derived: false }
                for (let k in sectionsPerSkill[skill]['sections'][sec][
                  secIndex
                ]) {
                  states[
                    sectionsPerSkill[skill]['sections'][sec][secIndex][k][
                      'state'
                    ]
                  ] = true
                }
                otherSections[otherSectionName] = states
              } else {
                for (let k in sectionsPerSkill[skill]['sections'][sec][
                  secIndex
                ]) {
                  sectionStates[
                    sectionsPerSkill[skill]['sections'][sec][secIndex][k][
                      'state'
                    ]
                  ] = true
                }
              }
            }
          }
        }

        let isResumeSkill = _.contains(
          resumeSkillsInLinkedin,
          skill.toLowerCase()
        )

        if (isResumeSkill == true) {
          skillsPresent.push(skill)
        } else {
          skillsPresent.push(skill)
        }
      }
      let selectedSkillKey = 0
      for (let index = 0; index < skillsPresent.length; index++) {
        if (skillsPresent[index] === this.state.selectedValue) {
          selectedSkillKey = index
        }
      }

      if (!_.isEmpty(skillsPresent)) {
        skillsPresent = _.map(skillsPresent, (value, key) => (
          <li
            key={key}
            className={this.state.selectedValue === value ? 'active' : ''}>
            {' '}
            <a
              data-value={value}
              data-module="skills"
              tabIndex={key <= selectedSkillKey ? tabIndex : 12}
              aria-label={value}
              role="button"
              onClick={() =>
                this.handleUpdateText(
                  value,
                  'skills',
                  feedback['skills']['relevant_skills_present'][currentIndex][
                    value
                  ],
                  currentSection
                )
              }>
              {' '}
              {value}{' '}
            </a>
          </li>
        ))
        skillsPresentBlock = (
          <div>
            <div className="keyword-heading">
              <span>
                <span>{divisionSubHeadlineText(intl)['skills']['present']}</span>
              </span>
            </div>
            <ul className="tab-keywords keywords-green">{skillsPresent}</ul>
          </div>
        )
      }
    }

    let skillsMissingResumeBlock = null
    let skillsMissingOtherBlock = null
    let skillsMissingResume = []
    let skillsMissingOther = []
    let relMissSkills = []
    if (
      data.hasOwnProperty('relevant_skills_missing') &&
      data['relevant_skills_missing'].hasOwnProperty(currentIndex)
    ) {
      relMissSkills = [].concat(data['relevant_skills_missing'][currentIndex])
    }

    if (!_.isEmpty(relMissSkills)) {
      let possessedSkills = {}
      // First prioritize hard skills by score, then soft skills by score
      let otherSkills = {
        hard_skills: {
          1: [],
          0.9: [],
          0.8: [],
          0.7: [],
          0.6: [],
          0.5: [],
        },
        sub_competency: {
          1: [],
          0.9: [],
          0.8: [],
          0.7: [],
          0.6: [],
          0.5: [],
        },
      }
      for (let i in relMissSkills) {
        let otherSections = {}
        let phrases = []
        let skill = relMissSkills[i]['word']
        if (sectionsPerSkill.hasOwnProperty(skill)) {
          phrases = sectionsPerSkill[skill]['phrases']
          for (let sec in sectionsPerSkill[skill]['sections']) {
            for (let secIndex in sectionsPerSkill[skill]['sections'][sec]) {
              if (sec != currentSection || secIndex != currentIndex) {
                let ind = parseInt(secIndex)
                let otherSectionName = ''
                if ((ind == 0) & (sec != currentSection)) {
                  otherSectionName = sec
                } else {
                  ind += 1
                  otherSectionName = sec + ' ' + ind
                }

                let states = { stated: false, derived: false }
                for (let k in sectionsPerSkill[skill]['sections'][sec][
                  secIndex
                ]) {
                  states[
                    sectionsPerSkill[skill]['sections'][sec][secIndex][k][
                      'state'
                    ]
                  ] = true
                }
                otherSections[otherSectionName] = states
              }
            }
          }
        }
        if (!_.isEmpty(phrases) || !_.isEmpty(otherSections)) {
          possessedSkills[skill] = {
            phrases: phrases,
            other_sections: otherSections,
            type: relMissSkills[i]['type'],
          }
        } else if (
          otherSkills[relMissSkills[i]['type']].hasOwnProperty(
            relMissSkills[i]['score']
          )
        ) {
          otherSkills[relMissSkills[i]['type']][relMissSkills[i]['score']].push(
            skill
          )
        }
      }

      let count = 0
      let skillsLimit = 10
      if (currentSection == 'Headline') {
        skillsLimit = 5
      }

      for (let skill in possessedSkills) {
        let isResumeSkill = _.contains(
          resumeSkillsNotInLinkedin,
          skill.toLowerCase()
        )

        if (isResumeSkill) {
          skillsMissingResume.push(
            <li key={skill}>
              <a
                role="button"
                tabIndex={12}
                aria-label={skill}
                onClick={() =>
                  this.handleResumeSkillsTracking('skills', 'skills', skill)
                }>
                {skill}
              </a>
            </li>
          )
        } else {
          skillsMissingOther.push(
            <li key={skill}>
              <a
                role="button"
                tabIndex={12}
                aria-label={skill}
                onClick={() =>
                  this.handleOtherSkillsTracking('skills', 'skills', skill)
                }>
                {' '}
                {skill}{' '}
              </a>
            </li>
          )
        }
        count += 1
        if (count == skillsLimit) {
          break
        }
      }

      for (let typeVar in otherSkills) {
        if (count == skillsLimit) {
          break
        }
        for (let score in otherSkills[typeVar]) {
          if (count == skillsLimit) {
            break
          }
          for (let k in otherSkills[typeVar][score]) {
            if (count == skillsLimit) {
              break
            }
            let skill = otherSkills[typeVar][score][k]

            let isResumeSkill = _.contains(
              resumeSkillsNotInLinkedin,
              skill.toLowerCase()
            )
            if (isResumeSkill) {
              skillsMissingResume.push(
                <li key={typeVar + score + k + ''}>
                  <a
                    role="button"
                    tabIndex={12}
                    aria-label={skill}
                    onClick={() =>
                      this.handleResumeSkillsTracking('skills', 'skills', skill)
                    }>
                    {skill}
                  </a>
                </li>
              )
            } else {
              skillsMissingOther.push(
                <li key={typeVar + score + k + ''}>
                  <a
                    role="button"
                    tabIndex={12}
                    aria-label={skill}
                    onClick={() =>
                      this.handleOtherSkillsTracking('skills', 'skills', skill)
                    }>
                    {' '}
                    {skill}{' '}
                  </a>
                </li>
              )
            }
            count += 1
          }
        }
      }
    }

    let suggestedSkillsOther = []
    if (
      !_.isUndefined(suggestedSkills) &&
      (suggestedSkills.hasOwnProperty('suggested_hard_skills') ||
        suggestedSkills.hasOwnProperty('suggested_sub_competency'))
    ) {
      if (!_.isEmpty(suggestedSkills['suggested_hard_skills'])) {
        let suggestedSkillsHard = this.getSuggestedSkillJsx({
          skill: 'hard_skill',
          suggestedSkill: suggestedSkills['suggested_hard_skills'],
          currentSection: currentSection,
          currentIndex: currentIndex,
        })
        suggestedSkillsOther = suggestedSkillsOther.concat(suggestedSkillsHard)
      }
      if (
        !_.isEmpty(suggestedSkills['suggested_sub_competency']) &&
        currentSection !== 'Headline'
      ) {
        let suggestedSkillsSoft = this.getSuggestedSkillJsx({
          skill: 'sub_competency',
          suggestedSkill: suggestedSkills['suggested_sub_competency'],
          currentSection: currentSection,
          currentIndex: currentIndex,
        })
        suggestedSkillsOther = suggestedSkillsOther.concat(suggestedSkillsSoft)
      }
    }

    if (!_.isEmpty(skillsMissingResume)) {
      let resumeKey = user && user.isResumeCalledCv ? 'cv' : 'resume'
      skillsMissingResumeBlock = (
        <div>
          <div className="keyword-heading">
            <span>
              <span>{divisionSubHeadlineText(intl)['skills'][resumeKey]}</span>
            </span>
          </div>
          <ul className="tab-keywords keywords-blue">{skillsMissingResume}</ul>
        </div>
      )
    }

    if (!_.isEmpty(suggestedSkillsOther)) {
      skillsMissingOtherBlock = (
        <div>
          <div className="keyword-heading">
            <span>
              <span>{divisionSubHeadlineText(intl)['skills']['missing']}</span>
            </span>
          </div>
          <div className="keyword-suggestion">
            {editModalAriaLabel(intl)[currentSection]['skill_try']}
          </div>
          <ul className="tab-keywords keywords-gray">{suggestedSkillsOther}</ul>
        </div>
      )
    }
    let bodyText = (
      <p>
        {intl.formatMessage({
          id: "aspire.sections.skillsFeedback.tryToInclude",
          defaultMessage: "Try to include skill-set relevant to your desired Job Function"
        })}
      </p>
    )
    let bodyLabel = intl.formatMessage({
      id: "aspire.sections.skillsFeedback.tryToInclude",
      defaultMessage: "Try to include skill-set relevant to your desired Job Function"
    })
    let pieScore = this.getModifiedScoreForPie(feedback, 'skills', currentIndex)
    let remainingPieScore = 100 - parseFloat(pieScore)
    let greenColorCode = '#46a74d'
    let yellowColorCode = '#f89d2f'
    let redColorCode = '#ef4f3e'
    let selectedColorCode = null

    if (feedback['skills']['score'][currentIndex]['color'] === 'red') {
      selectedColorCode = redColorCode
    } else if (
      feedback['skills']['score'][currentIndex]['color'] === 'yellow'
    ) {
      selectedColorCode = yellowColorCode
    } else if (feedback['skills']['score'][currentIndex]['color'] === 'green') {
      selectedColorCode = greenColorCode
    }

    let dataOptions = {
      datasets: [
        {
          data: [pieScore, remainingPieScore],
          backgroundColor: [selectedColorCode, '#E8E8E8'],
          borderColor: [selectedColorCode, '#E8E8E8'],
          borderWidth: 1,
        },
      ],
    }

    let options = {
      maintainAspectRatio: false,
      animation: {
        animateRotate: true,
      },
      tooltips: {
        enabled: false,
      },
      responsive: false,
    }
    let infoOverlay = (
      <Popover id="popover-sub-section-info">
        {intl.formatMessage({
          id: "aspire.sections.skillsFeedback.checkHowToDemonstrate",
          defaultMessage: "Check how to demonstrate skills in your LinkedIn profile."
        })}
      </Popover>
    )

    return (
      <div className="params-info-div">
        <div
          className={`params-info-header ${
            skillInclusionOpen ? '' : 'params-info-header-hide-bottom'
          } `}
          onClick={() => this.toggleInfoBox('skillInclusion')}>
          <div id="progress-bar-lable-skill" className="g-text">
            <span>
              {intl.formatMessage({
                id: "aspire.sections.skillsFeedback.skillInclusion",
                defaultMessage: "Skill Inclusion"
              })}
            </span>
          </div>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            rootClose
            overlay={infoOverlay}>
            <div className="as-info-icon">
              <a
                role="button"
                tabIndex={tabIndex}
                aria-label={infoScreenConnectLabel(intl)['skills']}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  this.showInfoModal('skills')
                }}>
                <img
                  className="as-info-icon-img"
                  alt="info icon"
                  src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
                />
              </a>
            </div>
          </OverlayTrigger>
          <div className="param-progress-bar-graph">
            <div className="progress-bar-main">
              <div
                className={
                  'progress-bar progress-bar-' +
                  feedback['skills']['score'][currentIndex]['color']
                }
                role="progressbar"
                aria-labelledby="progress-bar-lable-skill"
                aria-valuenow={pieScore}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: pieScore + '%' }}>
                <span className="visually-hidden">
                  {intl.formatMessage({
                    id: "aspire.sections.skillsFeedback.complete",
                    defaultMessage: "{percent}% Complete (success)",},
                    { percent: 40 }
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="arrow-div">
            <div
              className={`arrow arrow-${
                skillInclusionOpen ? 'bottom' : 'right'
              }`}></div>
          </div>
        </div>
        <div
          className={`params-info-desc params-info-desc${
            skillInclusionOpen ? '-show' : '-hidden'
          }`}
          style={{ minHeight: 'unset' }}
        >
          {skillsMissingOtherBlock}
          {skillsMissingResumeBlock}
          {skillsPresentBlock}
          <div
            className="prams-know-more-desc"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              this.showInfoModal('skills')
            }}>
            {intl.formatMessage({
              id: "aspire.sections.skillsFeedback.clickToKnowMore",
              defaultMessage: "Know more"
            })}{' '}
            <span className="icon icon-rightarrow" />
          </div>
        </div>
      </div>
    )
  }

  getSuggestedSkillJsx(value) {
    const { skill, suggestedSkill, currentSection, currentIndex } = value
    let suggestedSkills = []
    let count = 0
    _.mapObject(suggestedSkill, (value, key) => {
      if (
        Object.keys(value.section).includes(currentSection.toLowerCase()) &&
        Object.keys(value.sub_section).includes(currentSection.toLowerCase()) &&
        value.sub_section[currentSection.toLowerCase()].sub_section_id.includes(
          parseInt(currentIndex)
        ) &&
        ((skill == 'sub_competency' && count < 3) ||
          (skill == 'hard_skill' &&
            ((currentSection !== 'Headline' && count < 7) ||
              (currentSection === 'Headline' && count < 10))))
      ) {
        suggestedSkills.push(
          <li key={key + currentSection + currentIndex + ''}>
            <a
              role="button"
              tabIndex={12}
              aria-label={key}
              onClick={() =>
                this.handleOtherSkillsTracking('skills', 'skills', key)
              }>
              {' '}
              {this.toTitleCase(value.display_name)}{' '}
            </a>
          </li>
        )
        count = count + 1
      }
    })
    return suggestedSkills
  }

  toTitleCase(phrase) {
    return phrase
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  checkSectionWiseFedbackStructure(sectionNav, currentSection, currentIndex) {
    const { section_wise_feedback } = this.props
    // sectionWiseFeedbackCheckMap
    let feedbackSectionMap = {
      Experience: [
        'experience_feedback',
        {
          content: 'overall_content_score_class',
          skills: 'overall_skills_score_class',
          visibility: 'overall_profile_visibility_score_class',
        },
      ],
      Education: [
        'education_feedback',
        {
          content: 'overall_category_score_class',
          skills: '',
          visibility: 'overall_profile_visibility_score_class',
        },
      ],
      Summary: [
        'summary_feedback',
        {
          content: 'overall_content_score_class',
          skills: 'overall_skills_score_class',
          visibility: 'overall_profile_visibility_score_class',
        },
      ],
      Headline: [
        'headline_feedback',
        {
          content: 'overall_content_score_class',
          skills: 'overall_skills_score_class',
          visibility: 'overall_profile_visibility_score_class',
        },
      ],
      HeadlineOther: [
        'headline_feedback',
        {
          content: 'overall_category_score_class',
          skills: 'overall_skills_score_class',
          visibility: 'overall_profile_visibility_score_class',
        },
      ],
    }
    if (sectionNav !== 'skills') {
      if (['Experience', 'Education'].includes(currentSection)) {
        if (
          section_wise_feedback[
            feedbackSectionMap[currentSection][0]
          ].hasOwnProperty(
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ) &&
          section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ].hasOwnProperty('sub_section') &&
          section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ]['sub_section'].hasOwnProperty(currentIndex)
        ) {
          return section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ]['sub_section'][currentIndex]['color_feedback']
        }
      } else if (
        ['Headline', 'Summary', 'HeadlineOther'].includes(currentSection)
      ) {
        if (
          section_wise_feedback[
            feedbackSectionMap[currentSection][0]
          ].hasOwnProperty(
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ) &&
          section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ]['color_feedback']
        ) {
          return section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ]['color_feedback']
        }
      }
    } else if (sectionNav === 'skills') {
      if (['Experience', 'Education'].includes(currentSection)) {
        if (
          section_wise_feedback[
            feedbackSectionMap[currentSection][0]
          ].hasOwnProperty(
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ) &&
          section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ].hasOwnProperty('overall_score_class') &&
          section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ]['overall_score_class'].hasOwnProperty('sub_section') &&
          section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ]['overall_score_class']['sub_section'].hasOwnProperty(currentIndex)
        ) {
          return section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ]['overall_score_class']['sub_section'][currentIndex][
            'overall_score_class'
          ]['color_feedback']
        }
      } else if (
        ['Headline', 'Summary', 'HeadlineOther'].includes(currentSection)
      ) {
        if (
          section_wise_feedback[
            feedbackSectionMap[currentSection][0]
          ].hasOwnProperty(
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ) &&
          section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ].hasOwnProperty('overall_score_class') &&
          section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ]['overall_score_class']['color_feedback']
        ) {
          return section_wise_feedback[feedbackSectionMap[currentSection][0]][
            feedbackSectionMap[currentSection][1][[sectionNav]]
          ]['overall_score_class']['color_feedback']
        }
      }
    }
    return 'red'
  }

  getSectionNavScore(sectionNav, currentSection, currentIndex) {
    const { section_wise_feedback } = this.props
    if (sectionNav === 'content') {
      let paramsCount = this.getNoOfParams(sectionNav)
      if (currentSection === 'Experience' && !_.isNull(currentIndex)) {
        return this.checkSectionWiseFedbackStructure(
          sectionNav,
          currentSection,
          currentIndex
        )
      } else {
        if (currentSection === 'Education' && !_.isNull(currentIndex)) {
          return this.checkSectionWiseFedbackStructure(
            sectionNav,
            currentSection,
            currentIndex
          )
        } else if (currentSection === 'Summary') {
          return this.checkSectionWiseFedbackStructure(
            sectionNav,
            currentSection,
            currentIndex
          )
        } else if (currentSection === 'Headline') {
          if (paramsCount > 1) {
            return this.checkSectionWiseFedbackStructure(
              sectionNav,
              currentSection,
              currentIndex
            )
          } else {
            return this.checkSectionWiseFedbackStructure(
              sectionNav,
              'HeadlineOther',
              currentIndex
            )
          }
        }
      }
    } else if (sectionNav === 'skills') {
      if (currentSection === 'Experience' && !_.isNull(currentIndex)) {
        return this.checkSectionWiseFedbackStructure(
          sectionNav,
          currentSection,
          currentIndex
        )
      } else {
        if (currentSection === 'Summary') {
          return this.checkSectionWiseFedbackStructure(
            sectionNav,
            currentSection,
            currentIndex
          )
        } else if (currentSection === 'Headline') {
          return this.checkSectionWiseFedbackStructure(
            sectionNav,
            currentSection,
            currentIndex
          )
        }
      }
    } else if (sectionNav === 'visibility') {
      if (currentSection === 'Experience' && !_.isNull(currentIndex)) {
        return this.checkSectionWiseFedbackStructure(
          sectionNav,
          currentSection,
          currentIndex
        )
      } else if (currentSection === 'Education' && !_.isNull(currentIndex)) {
        return this.checkSectionWiseFedbackStructure(
          sectionNav,
          currentSection,
          currentIndex
        )
      } else if (currentSection === 'Summary') {
        return this.checkSectionWiseFedbackStructure(
          sectionNav,
          currentSection,
          currentIndex
        )
      } else if (currentSection === 'Headline') {
        return this.checkSectionWiseFedbackStructure(
          sectionNav,
          currentSection,
          currentIndex
        )
      }
    }
    return 'red'
  }

  renderNewSuggestedSeo(feedback, currentSection, currentIndex, tabIndex) {
    const { newSubSection, intl } = this.props
    const { seoKeywordOpen } = this.state
    if (_.isNull(currentIndex)) {
      currentIndex = 0
    }
    let keywordsIrrelevant = []
    if (
      feedback['seo'].hasOwnProperty('keywords') &&
      feedback['seo']['keywords'].hasOwnProperty(currentIndex) &&
      feedback['seo']['keywords'][currentIndex].hasOwnProperty('new_irrelevant')
    ) {
      keywordsIrrelevant = _.map(
        currentSection === 'Education'
          ? Object.fromEntries(
              Object.entries(
                feedback['seo']['keywords'][currentIndex]['new_irrelevant']
              ).slice(0, 5)
            )
          : feedback['seo']['keywords'][currentIndex]['new_irrelevant'],
        (value, key) => (
          <li key={value}>
            <a
              tabIndex={12}
              aria-label={value}
              role="button"
              onClick={() =>
                this.handleGraySkillsSeoTracking('visibility', 'seo', value)
              }>
              {' '}
              {value}{' '}
            </a>
          </li>
        )
      )
    }

    let irrelevant = null
    if (!_.isEmpty(keywordsIrrelevant)) {
      irrelevant = (
        <div>
          <div className="keyword-heading">
            <span>
              {intl.formatMessage({
                id: "aspire.sections.seoKeywords.missing",
                defaultMessage: "Missing Keywords"
              })}
            </span>
          </div>
          <ul className="tab-keywords keywords-gray">{keywordsIrrelevant}</ul>
        </div>
      )
    } else {
      irrelevant = (
        <div>
          <div className="keyword-heading">
            <span>
              {intl.formatMessage({
                id: "aspire.sections.seoKeywords.missing",
                defaultMessage: "Missing Keywords"
              })}
            </span>
          </div>
          <div className="keyword-suggestion-static">
            {intl.formatMessage({
              id: "aspire.sections.seoKeywords.suggestion",
              defaultMessage:
                "Optimize your profile by adding strategic keywords throughout your profile to increase the likelihood of your profile appearing in search results. Gain competitive advantage by highlighting unique skills, experiences, or qualifications."
            })}
          </div>
        </div>
      )
    }
    let infoOverlay = (
      <Popover id="popover-sub-section-info">
        {intl.formatMessage({
          id: "aspire.sections.seoKeywords.infoOverlay",
          defaultMessage: "Check the importance of profile visibility in your LinkedIn profile."
        })}
      </Popover>
    )

    return (
      <div className="params-info-div">
        <div
          className={`params-info-header ${
            seoKeywordOpen ? '' : 'params-info-header-hide-bottom'
          }`}
          onClick={() => {
            this.toggleInfoBox('seoKeyword')
          }}>
          <div id="progress-bar-lable-seo" className="g-text">
            <span>
              {intl.formatMessage({
                id: "aspire.sections.seoKeywords.heading",
                defaultMessage: "SEO Keywords"
              })}
            </span>
          </div>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            rootClose
            overlay={infoOverlay}>
            <div className="as-info-icon">
              <a
                role="button"
                tabIndex={tabIndex}
                aria-label={infoScreenConnectLabel(intl)['seo']}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  this.showInfoModal('seo')
                }}>
                <img
                  className="as-info-icon-img"
                  alt="info icon"
                  src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
                />
              </a>
            </div>
          </OverlayTrigger>
          <div className="arrow-div">
            <div
              className={`arrow arrow-${
                seoKeywordOpen ? 'bottom' : 'right'
              }`}></div>
          </div>
        </div>
        <div
          className={`params-info-desc params-info-desc${
            seoKeywordOpen ? '-show' : '-hidden'
          }`}
          style={{ minHeight: 'unset' }}
        >
          {irrelevant}
          <div
            className="prams-know-more-desc"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              this.showInfoModal('seo')
            }}>
            {intl.formatMessage({
              id: "aspire.sections.seoKeywords.clickToKnowMore",
              defaultMessage: "Know more"
            })}{' '}
            <span className="icon icon-rightarrow" />
          </div>
        </div>
      </div>
    )
  }

  renderSeoFeedback(feedback, currentSection, currentIndex, tabIndex) {
    if (!this.renderModuleFeedback['seo']) {
      return null
    }
    const { seoKeywordOpen } = this.state
    const { intl } = this.props
    let keywordsRelevant = []

    if (
      feedback['seo'].hasOwnProperty('keywords') &&
      !_.isEmpty(feedback['seo']['keywords'][currentIndex]['relevant'])
    ) {
      let selectedSeoKey = {}
      let selectedSeoMatch = false

      for (var value in feedback['seo']['keywords'][currentIndex]['relevant']) {
        if (
          feedback['seo']['keywords'][currentIndex]['relevant'].hasOwnProperty(
            this.state.selectedValue
          )
        ) {
          if (value == this.state.selectedValue || !selectedSeoMatch) {
            selectedSeoMatch = true
            selectedSeoKey[value] = 11
          } else {
            selectedSeoKey[value] = 12
          }
        } else {
          selectedSeoKey[value] = 11
        }
      }

      keywordsRelevant = _.map(
        feedback['seo']['keywords'][currentIndex]['relevant'],
        (value, key) =>
          _.isEmpty(key) ? null : (
            <li
              key={key}
              className={this.state.selectedValue === key ? 'active' : ''}>
              <a
                data-value={key}
                data-module="seo"
                tabIndex={selectedSeoKey[key]}
                aria-label={key}
                role="button"
                onClick={() =>
                  this.handleUpdateText(
                    key,
                    'seo',
                    feedback['seo']['keywords'][currentIndex]['relevant'][key],
                    currentSection
                  )
                }>
                {' '}
                {key}{' '}
              </a>
            </li>
          )
      )
    }

    let relevant = null

    if (!_.isEmpty(keywordsRelevant)) {
      relevant = (
        <div>
          <div className="keyword-heading">
            <span>{divisionSubHeadlineText(intl)['visibility']['present']}</span>
          </div>
          <ul className="tab-keywords keywords-green">{keywordsRelevant}</ul>
        </div>
      )
    }

    let keywordsIrrelevant = []

    if (feedback['seo'].hasOwnProperty('keywords')) {
      keywordsIrrelevant = _.map(
        currentSection === 'Education'
          ? Object.fromEntries(
              Object.entries(
                feedback['seo']['keywords'][currentIndex]['irrelevant']
              ).slice(0, 5)
            )
          : feedback['seo']['keywords'][currentIndex]['irrelevant'],
        (value, key) => (
          <li key={key}>
            <a
              tabIndex={12}
              aria-label={key}
              role="button"
              onClick={() =>
                this.handleGraySkillsSeoTracking('visibility', 'seo', key)
              }>
              {' '}
              {key}{' '}
            </a>
          </li>
        )
      )
    }

    let irrelevant = null

    if (!_.isEmpty(keywordsIrrelevant)) {
      irrelevant = (
        <div>
          <div className="keyword-heading">
            <span>
              {this.props.intl.formatMessage({
                id: "aspire.sections.seoKeywords.missing",
                defaultMessage: "Missing Keywords"
              })}
            </span>
          </div>
          <ul className="tab-keywords keywords-gray">{keywordsIrrelevant}</ul>
        </div>
      )
    }

    let bodyText =
      feedbackContent(intl)[feedback['seo']['score'][currentIndex]['color']]['body'][
        'seo'
      ]

    let bodyLabel =
      feedbackAriaLabel(intl)[feedback['seo']['score'][currentIndex]['color']][
        'body'
      ]['seo']
    if (
      _.isEmpty(irrelevant) &&
      feedback['seo']['score'][currentIndex]['color'] == 'red'
    ) {
      bodyText = (
        <p>
          {this.props.intl.formatMessage({
            id: "aspire.sections.seoKeywords.tryToInclude",
            defaultMessage: "Try to include more relevant keywords. Check the edit mode to see which skills and categories you can add."
          })}
        </p>
      )
      bodyLabel = this.props.intl.formatMessage({
        id: "aspire.sections.seoKeywords.tryToInclude",
        defaultMessage: "Try to include more relevant keywords. Check the edit mode to see which skills and categories you can add."
      })
    }

    let pieScore = this.getModifiedScoreForPie(feedback, 'seo', currentIndex)
    let remainingPieScore = 100 - parseFloat(pieScore)
    let greenColorCode = '#46a74d'
    let yellowColorCode = '#f89d2f'
    let redColorCode = '#ef4f3e'
    let selectedColorCode = null

    if (feedback['seo']['score'][currentIndex]['color'] === 'red') {
      selectedColorCode = redColorCode
    } else if (feedback['seo']['score'][currentIndex]['color'] === 'yellow') {
      selectedColorCode = yellowColorCode
    } else if (feedback['seo']['score'][currentIndex]['color'] === 'green') {
      selectedColorCode = greenColorCode
    }

    let dataOptions = {
      datasets: [
        {
          data: [pieScore, remainingPieScore],
          backgroundColor: [selectedColorCode, '#E8E8E8'],
          borderColor: [selectedColorCode, '#E8E8E8'],
          borderWidth: 1,
        },
      ],
    }

    let options = {
      maintainAspectRatio: false,
      animation: {
        animateRotate: true,
      },
      tooltips: {
        enabled: false,
      },
      responsive: false,
    }
    
    let infoOverlay = (
      <Popover id="popover-sub-section-info">
        {this.props.intl.formatMessage({
          id: "aspire.sections.seoKeywords.infoOverlay",
          defaultMessage: "Check the importance of profile visibility in your LinkedIn profile."
        })}
      </Popover>
    )

    return (
      <div className="params-info-div">
        <div
          className={`params-info-header ${
            seoKeywordOpen ? '' : 'params-info-header-hide-bottom'
          }`}
          onClick={() => {
            this.toggleInfoBox('seoKeyword')
          }}>
          <div id="progress-bar-lable-seo" className="g-text">
            <span>
              {this.props.intl.formatMessage({
                id: "aspire.sections.seoKeywords.heading",
                defaultMessage: "SEO Keywords"
              })}
            </span>
          </div>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            rootClose
            overlay={infoOverlay}>
            <div className="as-info-icon">
              <a
                role="button"
                tabIndex={tabIndex}
                aria-label={infoScreenConnectLabel(intl)['seo']}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  this.showInfoModal('seo')
                }}>
                <img
                  className="as-info-icon-img"
                  alt="info icon"
                  src={`${process.env.APP_BASE_URL}dist/images/as-info-icon.svg`}
                />
              </a>
            </div>
          </OverlayTrigger>
          <div className="param-progress-bar-graph">
            <div className="progress-bar-main">
              <div
                className={
                  'progress-bar progress-bar-' +
                  feedback['seo']['score'][currentIndex]['color']
                }
                role="progressbar"
                aria-labelledby="progress-bar-lable-seo"
                aria-valuenow={pieScore}
                aria-valuemin="0"
                aria-valuemax="100"
                style={{ width: pieScore + '%' }}>
                <span className="visually-hidden">
                  {this.props.intl.formatMessage({
                    id: "aspire.sections.seoKeywords.complete",
                    defaultMessage: "{percent}% Complete (success)",},
                    { percent: 40 }
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="arrow-div">
            <div
              className={`arrow arrow-${
                seoKeywordOpen ? 'bottom' : 'right'
              }`}></div>
          </div>
        </div>
        <div
          className={`params-info-desc params-info-desc${
            seoKeywordOpen ? '-show' : '-hidden'
          }`}
          style={{ minHeight: 'unset' }}
        >
          {irrelevant}
          {relevant}
          <div
            className="prams-know-more-desc"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              this.showInfoModal('seo')
            }}>
            {this.props.intl.formatMessage({
              id: "aspire.sections.seoKeywords.clickToKnowMore",
              defaultMessage: "Know more"
            })}{' '}
            <span className="icon icon-rightarrow" />
          </div>
        </div>
      </div>
    )
  }

  showInfoModal(module) {
    this.sendTrackingDataDebounceInfoModal(
      'event',
      'aspire_info_screen_open',
      'click',
      module
    )
    this.setState({ showInfoScreen: true, activeInfoScreen: module })
  }

  hideInfoModal() {
    sendTrackingData(
      'event',
      'aspire_info_screen_close',
      'click',
      this.state.activeInfoScreen
    )
    this.setState({ showInfoScreen: false, activeInfoScreen: '' })
  }

  getModifiedScoreForPie(feedback, subsection, currentIndex) {
    let sectionScore = feedback[subsection]['score'][currentIndex]['score']

    if (feedback[subsection]['score'][currentIndex]['score'] <= 7) {
      sectionScore = 7
    } else if (feedback[subsection]['score'][currentIndex]['score'] >= 93) {
      sectionScore = 93
    }

    return sectionScore
  }

  handleResumeSkillsTracking(sectionNav, module, value) {
    let countOfAvailableClick = this.getNoOfModules(sectionNav)
    let jsonObjectForTracking = {
      eventLabel: 'feedback_panel_nav_resume_skills_info',
      currentSection: this.props.currentSection,
      currentIndex: this.props.currentIndex,
      sectionNav: sectionNav,
      selectedModule: module,
      selectedValue: value,
      countOfAvailableClick: countOfAvailableClick,
    }
    this.sendTrackingDataDebounceResumeClicks(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }

  handleOtherSkillsTracking(sectionNav, module, value) {
    let countOfAvailableClick = this.getNoOfModules(sectionNav)
    let jsonObjectForTracking = {
      eventLabel: 'feedback_panel_nav_other_skills_info',
      currentSection: this.props.currentSection,
      currentIndex: this.props.currentIndex,
      sectionNav: sectionNav,
      selectedModule: module,
      selectedValue: value,
      countOfAvailableClick: countOfAvailableClick,
    }
    this.sendTrackingDataDebounceOtherClicks(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }

  handleGraySkillsSeoTracking(sectionNav, module, value) {
    let countOfAvailableClick = this.getNoOfModules(sectionNav)
    let jsonObjectForTracking = {
      eventLabel: 'feedback_panel_nav_gray_skills_seo_info',
      currentSection: this.props.currentSection,
      currentIndex: this.props.currentIndex,
      sectionNav: sectionNav,
      selectedModule: module,
      selectedValue: value,
      countOfAvailableClick: countOfAvailableClick,
    }
    this.sendTrackingDataDebounceGraySkillsSeo(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }

  handleGrayCategoriesTracking(sectionNav, module, value) {
    let countOfAvailableClick = this.getNoOfModules(sectionNav)
    let jsonObjectForTracking = {
      eventLabel: 'feedback_panel_nav_gray_categories_info',
      currentSection: this.props.currentSection,
      currentIndex: this.props.currentIndex,
      sectionNav: sectionNav,
      selectedModule: module,
      selectedValue: value,
      countOfAvailableClick: countOfAvailableClick,
    }
    this.sendTrackingDataDebounceGrayCategories(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }

  handleResumeCategoriesTracking(sectionNav, module, value) {
    let countOfAvailableClick = this.getNoOfModules(sectionNav)
    let jsonObjectForTracking = {
      eventLabel: 'feedback_panel_nav_resume_categories_info',
      currentSection: this.props.currentSection,
      currentIndex: this.props.currentIndex,
      sectionNav: sectionNav,
      selectedModule: module,
      selectedValue: value,
      countOfAvailableClick: countOfAvailableClick,
    }
    this.sendTrackingDataDebounceGrayCategories(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }

  handleUpdateText(value, module, idsObj, currentSection) {
    let sectionNav = moduleToNavMapping[module]
    let countOfAvailableClick = this.getNoOfModules(sectionNav)
    if (module == 'language' || module == 'impact') {
      this.setState({ selectedLanguageImpact: value })
    }
    if (module == 'presentation') this.setState({ selectedPresentation: value })
    if (!_.isUndefined(idsObj) && !_.isNull(idsObj)) {
      this.idsObj = idsObj
      this.setState({ selectedValue: value, selectedModule: module })
    } else {
      this.props.onUpdateText(value, -1)
    }
  }

  setSelectedPresentCategory(category) {
    this.setState({ selectedPresentCategory: category })
  }

  handlePresentModuleCategoryClick(category) {
    const {
      highlightEntityText,
      unhighlightAll,
      sectionWiseTextEditable,
      dataContent,
      currentIndex,
      currentSection,
      isUKEnable = false,
    } = this.props
    const { selectedModule, selectedValue } = this.state
    unhighlightAll()
    let type = 'static'

    let jsonObjectForTracking = {
      eventLabel:
        selectedModule === 'skills'
          ? 'skills_guide_present_skill_click'
          : 'content_guide_present_category_click',
      currentSection: currentSection,
      currentIndex: currentIndex,
      module: selectedModule === 'skills' ? 'skills' : 'content',
      type: type,
    }

    this.trackPresentCategoriesClick(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )

    let finalTexts = []
    highlightEntityText(selectedModule, category, type, finalTexts, this.idsObj)
    this.setSelectedPresentCategory(category)
  }

  handleImpactModulesClick(mod, submodule) {
    const {
      highlightEntityText,
      unhighlightAll,
      currentSection,
      currentIndex,
    } = this.props
    const { checkbox } = this.state
    unhighlightAll()
    let type = 'static'
    let jsonObjectForTracking = {
      eventLabel: 'impact_guide_switch_click',
      currentSection: currentSection,
      currentIndex: currentIndex,
      module: mod,
      submodule: submodule,
      type: type,
    }

    this.trackPresentCategoriesClick(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )

    let tempCheckbox = $.extend(true, {}, checkbox)
    for (let i in tempCheckbox) {
      if (i == submodule) {
        tempCheckbox[i] = true
        unhighlightAll()
        highlightEntityText(mod, i, type)
      } else {
        tempCheckbox[i] = false
      }
    }
    this.updateCheckboxState(tempCheckbox)
  }

  handlePresentationModulesClick(mod, submodule) {
    const {
      highlightEntityText,
      unhighlightAll,
      currentSection,
      currentIndex,
    } = this.props
    const { checkboxPresentation } = this.state
    unhighlightAll()
    let type = 'static'
    let jsonObjectForTracking = {
      eventLabel: 'presentation_guide_switch_click',
      currentSection: currentSection,
      currentIndex: currentIndex,
      module: mod,
      submodule: submodule,
      type: type,
    }

    this.trackPresentCategoriesClick(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )

    let tempCheckboxPresentation = $.extend(true, {}, checkboxPresentation)
    for (let i in tempCheckboxPresentation) {
      if (i == submodule) {
        tempCheckboxPresentation[i] = true
        unhighlightAll()
        highlightEntityText(mod, i, type)
      } else {
        tempCheckboxPresentation[i] = false
      }
    }
    this.updateCheckboxPresentationState(tempCheckboxPresentation)
  }

  updateCheckboxState(checkbox) {
    this.setState({ checkbox: checkbox })
  }

  updateCheckboxPresentationState(checkboxPresentation) {
    this.setState({ checkboxPresentation: checkboxPresentation })
  }

  genAiIdsObj(idsObj) {
    const newIdsObj = { ids: {}, pos_present: true };
    Object.entries(idsObj.ids).forEach(([divId, arr]) => {
      let el = document.querySelector(`.hwt-input`);
      if (!el) el = document.querySelector('.div-id-' + divId);
      if (el) {
        const text = el.textContent || '';
        const uniqueWords = [...new Set(arr.map(obj => obj.word))];
        newIdsObj.ids[divId] = [];
        uniqueWords.forEach(word => {
          const positions = this.findAllPositions(text, word);
          positions.forEach(pos => {
            newIdsObj.ids[divId].push({ word, pos });
          });
        });
      }
    });
    return newIdsObj;
  }

  handleSelection() {
    const { currentSection, isGenAiFeedback } = this.props
    let value = this.state.selectedValue
    let module = this.state.selectedModule
    let idsObj = this.idsObj

    if (
      !_.isUndefined(idsObj) &&
      !_.isNull(idsObj) &&
      !(this.prevSelectedValue == value && this.prevSelectedModule == module)
    ) {
      this.prevSelectedModule = module
      this.prevSelectedValue = value

      if (module == 'language') {
        let selector = 'div.tab div.' + value + ' a'
        let obj = $(selector)

        if (obj?.hasOwnProperty(0)) {
          obj[0].click()
        }

        if (value == 'buzzwords') {
          if( isGenAiFeedback ) {
            const newIdsObj = this.genAiIdsObj(idsObj);
            this.props.onUpdateText(newIdsObj['ids'], 2, currentSection, 'highlight-red')
          }
          else {
            if (
              _.isUndefined(idsObj['pos_present']) ||
              idsObj['pos_present'] == false
            ) {
              this.props.onUpdateText(
                idsObj['ids'],
                1,
                currentSection,
                'highlight-red'
              )
            } else {
              this.props.onUpdateText(
                idsObj['ids'],
                2,
                currentSection,
                'highlight-red'
              )
            }
          }
        } else if (value == 'verb_overusage') {
          if( isGenAiFeedback ) {
            const newIdsObj = this.genAiIdsObj(idsObj);
            this.props.onUpdateText(newIdsObj['ids'], 2, currentSection, 'highlight-red')
          }
          else {
            if (
              _.isUndefined(idsObj['pos_present']) ||
              idsObj['pos_present'] == false
            ) {
              this.props.onUpdateText(
                idsObj['ids'],
                1,
                currentSection,
                'highlight-red'
              )
            } else {
              this.props.onUpdateText(
                idsObj['ids'],
                2,
                currentSection,
                'highlight-red'
              )
            }
          }
        } else if (value == 'narrative_voice' || value == 'tense') {
          this.props.onUpdateText(
            idsObj['ids'],
            3,
            currentSection,
            'highlight-red'
          )
        }
      } else if (module == 'impact') {
        let selector = 'div.tab div.' + value + ' a'
        let obj = $(selector)

        if (obj.hasOwnProperty(0)) {
          obj[0].click()
        }

        if (value == 'specifics') {
          if( isGenAiFeedback ) {
            const newIdsObj = this.genAiIdsObj(idsObj);
            this.props.onUpdateText(newIdsObj['ids'], 2, currentSection)
          }
          else {
            if (
              _.isUndefined(idsObj['pos_present']) ||
              idsObj['pos_present'] == false
            ) {
              this.props.onUpdateText(idsObj['ids'], 1, currentSection)
            } else {
              this.props.onUpdateText(idsObj['ids'], 2, currentSection)
            }
          }
        } else if (value == 'action_oriented') {
          if( isGenAiFeedback ) {
            const newIds = {};
            Object.entries(idsObj['ids']).forEach(([divId, arr]) => {
              let el = document.querySelector(`.hwt-input`)
              if(!el) el = document.querySelector('.div-id-' + divId);
              if(el) {
                const text = el.textContent || '';
                newIds[divId] = [];
                arr.forEach(obj => {
                  const positions = this.findAllPositions(text, obj.word);
                  positions.forEach(pos => {
                    newIds[divId].push({
                      word: obj.word,
                      pos: pos,
                      strength: obj.strength
                    });
                  });
                });
              }
            });
            const weakWords = {};
            const strongOrMediumWords = {};

            Object.entries(newIds).forEach(([divId, words]) => {
              const weakWordsForDiv = words.filter(w => w.strength === 'weak').map(w => ({ word: w.word, pos: w.pos }));
              const strongOrMediumWordsForDiv = words.filter(w => w.strength === 'strong' || w.strength === 'medium').map(w => ({ word: w.word, pos: w.pos }));
              
              if (weakWordsForDiv.length > 0) {
                weakWords[divId] = weakWordsForDiv;
              }
              
              if (strongOrMediumWordsForDiv.length > 0) {
                strongOrMediumWords[divId] = strongOrMediumWordsForDiv;
              }
            });
            const mergedWords = {};
            Object.keys(weakWords).forEach(divId => {
              mergedWords[divId] = weakWords[divId].map(w => ({ ...w, color: 'red' }));
            });
            Object.keys(strongOrMediumWords).forEach(divId => {
              if (!mergedWords[divId]) mergedWords[divId] = [];
              mergedWords[divId] = mergedWords[divId].concat(
                strongOrMediumWords[divId].map(w => ({ ...w, color: 'green' }))
              );
            });
            if (Object.keys(mergedWords).length > 0) {
              this.props.onUpdateText(mergedWords, 8, currentSection);
            }
          }
          else {
            let divIds = []
            let weakObj = {}

            for (let divId in idsObj['ids']) {
              if (!_.isEmpty(idsObj['ids'][divId])) {
                divIds.push(divId)
                weakObj[divId] = []
                for (let i in idsObj['ids'][divId]) {
                  if (idsObj['ids'][divId][i]['weak'] === true) {
                    weakObj[divId].push(idsObj['ids'][divId][i])
                  }
                }
              }
            }

            if (
              _.isUndefined(idsObj['pos_present']) ||
              idsObj['pos_present'] == false
            ) {
              this.props.onUpdateText(
                { weak_obj: weakObj, div_ids: divIds },
                6,
                currentSection
              )
            } else {
              this.props.onUpdateText(
                { weak_obj: weakObj, div_ids: divIds },
                7,
                currentSection
              )
            }
          }
        }
      } else if (module == 'categories') {
        if( isGenAiFeedback ) {
          const newIdsObj = this.genAiIdsObj(idsObj);
          this.props.onUpdateText(newIdsObj['ids'], 2, currentSection)
        }
        else {
          if (
            _.isUndefined(idsObj['pos_present']) ||
            idsObj['pos_present'] === false
          ) {
            this.props.onUpdateText(idsObj['ids'], 1, currentSection)
          } else {
            this.props.onUpdateText(idsObj['ids'], 2, currentSection)
          }
        }
      } else if (module == 'seo') {
        let idsObj2 = {}

        for (let index in idsObj) {
          if (!idsObj2.hasOwnProperty(idsObj[index]['id'])) {
            idsObj2[idsObj[index]['id']] = []
          }
          idsObj2[idsObj[index]['id']].push({
            pos: idsObj[index]['pos'],
            word: value,
          })
        }
        if( isGenAiFeedback ) {
          const wrappedIdsObj2 = { ids: idsObj2, pos_present: true };
          const newIdsObj = this.genAiIdsObj(wrappedIdsObj2);
          this.props.onUpdateText(newIdsObj['ids'], 2, currentSection)
        } else {
          this.props.onUpdateText(idsObj2, 2, currentSection)
        }
      } else if (module == 'skills') {
        if (currentSection == 'Skills') {
          this.props.onUpdateText(
            _.map(idsObj, (value, key) => value['id']),
            5,
            currentSection
          )
        } else if (currentSection == 'Headline') {
          let statedIds = []

          for (let i in idsObj) {
            if (idsObj[i]['state'] == 'stated') {
              statedIds.push(idsObj[i]['id'])
            }
          }
          // this.props.onUpdateText({ 'word': value, 'ids': statedIds }, 4, currentSection)
          // new code for handling headline highlighting for stated skills
          let word = value
          if (
            idsObj.hasOwnProperty(0) &&
            idsObj[0].hasOwnProperty('stated_actual_keyword') &&
            idsObj[0]['stated_actual_keyword'] != ''
          ) {
            word = idsObj[0]['stated_actual_keyword']
          }
          this.props.onUpdateText(
            { word: word, ids: statedIds },
            4,
            currentSection
          )
        } else {
          this.props.onUpdateText(
            _.map(idsObj, (value, key) => value['id']),
            3,
            currentSection
          )
        }
      } else if (module == 'presentation') {
        let selector = 'div.tab div.' + value + ' a'
        let obj = $(selector)

        if (obj.hasOwnProperty(0)) {
          obj[0].click()
        }

        if (value == 'bullet_length') {
          if (
            _.isUndefined(idsObj['pos_present']) ||
            idsObj['pos_present'] == false
          ) {
            this.props.onUpdateText(
              idsObj['ids'],
              1,
              currentSection,
              'highlight-red'
            )
          } else {
            this.props.onUpdateText(
              idsObj['ids'],
              2,
              currentSection,
              'highlight-red'
            )
          }
        } else if (value == 'bullets_count') {
          if (
            _.isUndefined(idsObj['pos_present']) ||
            idsObj['pos_present'] == false
          ) {
            this.props.onUpdateText(
              idsObj['ids'],
              1,
              currentSection,
              'highlight-red'
            )
          } else {
            this.props.onUpdateText(
              idsObj['ids'],
              2,
              currentSection,
              'highlight-red'
            )
          }
        } else if (value == 'grammar') {
          if (
            _.isUndefined(idsObj['pos_present']) ||
            idsObj['pos_present'] == false
          ) {
            this.props.onUpdateText(
              idsObj['ids'],
              1,
              currentSection,
              'highlight-red'
            )
          } else {
            this.props.onUpdateText(
              idsObj['ids'],
              2,
              currentSection,
              'highlight-red'
            )
          }
        }
      }
    }
  }

  handleMouseOver(e) {
    let value = $(e.target).closest('[data-value]').data('value')
    let module = $(e.target).closest('[data-module]').data('module')
    this.setState({ hoveredValue: value, hoveredModule: module })
  }

  handleMouseOut(e) {
    this.setState({ hoveredValue: '', hoveredModule: '' })
  }

  getFirstDivId(value, module, idsObj, currentSection, firstDivId) {
    return '#' + sectionUnderscore[currentSection]

    /* ignore this for now - under testing as on 05-10-2017 */
    if (module == 'language') {
      if (value == 'buzzwords' || value == 'verb_overusage') {
        if (!_.isUndefined(idsObj['ids']) && !_.isEmpty(idsObj['ids'])) {
          let keys = _.keys(idsObj['ids'])
          let minKey = parseInt(_.min(keys))
          if (minKey > firstDivId + 20) {
            minKey = Math.ceil((minKey - firstDivId) / 20) * 20 + firstDivId
            return '#profile-data-' + minKey
          }
        }
      } else if (value == 'tense' || value == 'narrative_voice') {
        if (!_.isUndefined(idsObj['ids']) && !_.isEmpty(idsObj['ids'])) {
          let minKey = parseInt(_.min(idsObj['ids']))
          if (minKey > firstDivId + 20) {
            minKey = Math.ceil((minKey - firstDivId) / 20) * 20 + firstDivId
            return '#profile-data-' + minKey
          }
        }
      }
    } else if (module == 'impact') {
      if (value == 'action_oriented' || value == 'specifics') {
        if (!_.isUndefined(idsObj['ids']) && !_.isEmpty(idsObj['ids'])) {
          let keys = _.keys(idsObj['ids'])
          let minKey = parseInt(_.min(keys))
          if (minKey > firstDivId + 20) {
            minKey = Math.ceil((minKey - firstDivId) / 20) * 20 + firstDivId
            return '#profile-data-' + minKey
          }
        }
      }
    } else if (module == 'categories') {
      if (!_.isUndefined(idsObj['ids']) && !_.isEmpty(idsObj['ids'])) {
        let keys = _.keys(idsObj['ids'])
        let minKey = parseInt(_.min(keys))
        if (minKey > firstDivId + 20) {
          minKey = Math.ceil((minKey - firstDivId) / 20) * 20 + firstDivId
          return '#profile-data-' + minKey
        }
      }
    } else if (module == 'seo') {
      if (!_.isEmpty(idsObj)) {
        let minKey = parseInt(
          _.min(
            _.map(idsObj, function (v) {
              return v['id']
            })
          )
        )
        if (minKey > firstDivId + 20) {
          minKey = Math.ceil((minKey - firstDivId) / 20) * 20 + firstDivId
          return '#profile-data-' + minKey
        }
      }
    } else if (module == 'skills') {
      if (currentSection == 'Headline') {
        let keys = []
        for (let i in idsObj) {
          if (idsObj[i]['state'] == 'stated') {
            keys.push(idsObj[i]['id'])
          }
        }
        if (!_.isEmpty(keys)) {
          let minKey = parseInt(_.min(keys))
          if (minKey > firstDivId + 20) {
            minKey = Math.ceil((minKey - firstDivId) / 20) * 20 + firstDivId
            return '#profile-data-' + minKey
          }
        }
      } else {
        let keys = []
        if (!_.isEmpty(idsObj)) {
          for (let i in idsObj) {
            keys.push(idsObj[i]['id'])
          }
        }
        let minKey = parseInt(_.min(keys))
        if (minKey > firstDivId + 20) {
          minKey = Math.ceil((minKey - firstDivId) / 20) * 20 + firstDivId
          return '#profile-data-' + minKey
        }
      }
    }

    return '#' + sectionUnderscore[currentSection]
  }

  getNoOfModules(sectionNav) {
    let count = 0
    if (sectionNav == 'content') {
      if (this.renderModuleFeedback['language'] == true) {
        count = count + 4
      }
      if (this.renderModuleFeedback['impact'] == true) {
        count = count + 2
      }
      if (this.renderModuleFeedback['categories'] == true) {
        count = count + 1
      }
    }

    if (sectionNav == 'skills') {
      if (this.renderModuleFeedback['skills'] == true) {
        count = count + 1
      }
    }
    if (sectionNav == 'visibility') {
      if (this.renderModuleFeedback['seo'] == true) {
        count = count + 1
      }
    }

    return count
  }

  getNoOfParams(sectionNav) {
    let count = 0
    if (sectionNav == 'content') {
      if (this.renderModuleFeedback['language'] == true) {
        count++
      }
      if (this.renderModuleFeedback['impact'] == true) {
        count++
      }
      if (this.renderModuleFeedback['categories'] == true) {
        count++
      }
    }

    if (sectionNav == 'skills') {
      if (this.renderModuleFeedback['skills'] == true) {
        count++
      }
    }
    if (sectionNav == 'visibility') {
      if (this.renderModuleFeedback['seo'] == true) {
        count++
      }
    }

    return count
  }

  handleClick(e) {
    const { currentSection } = this.props
    this.prevSelectedModule = ''
    this.prevSelectedValue = ''
    this.props.unhighlightAll()
    let i = $(e.target).closest('[data-navindex]').data('navindex')
    let sectionNav = sectionNavs[currentSection][i]
    let countOfAvailableClick = this.getNoOfModules(sectionNav)
    let sectionNavName = modsMap[sectionNav]
    let defaultSelectedValue = this.getDefaultSelectedValue(
      sectionNav,
      this.props
    )
    this.idsObj = defaultSelectedValue['idsObj']
    let selectedLanguageImpact =
      defaultSelectedValue['module'] == 'language' ||
      defaultSelectedValue['module'] == 'impact'
        ? defaultSelectedValue['value']
        : ''
    
    let selectedPresentation =
      defaultSelectedValue['module'] == 'presentation'
        ? defaultSelectedValue['value']
        : ''

    let jsonObjectForTracking = {
      eventLabel: 'feedback_panel_nav_click_info',
      currentSection: currentSection,
      sectionNav: sectionNav,
      selectedModule: defaultSelectedValue['module'],
      selectedValue: defaultSelectedValue['value'],
      countOfAvailableClick: countOfAvailableClick,
    }

    this.sendTrackingDataDebounceOtherClicks(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )

    this.setState({
      hoveredValue: '',
      hoveredModule: '',
      selectedValue: defaultSelectedValue['value'],
      selectedModule: defaultSelectedValue['module'],
      selectedLanguageImpact: selectedLanguageImpact,
      selectedPresentation: selectedPresentation,
    })
    this.props.resetSectionNavs(i)
  }

  getFirstModuleKeywords(props) {
    const { feedback, ui, currentSection } = props
    const currentIndex = ui.currentIndex

    if (
      feedback.hasOwnProperty('categories') &&
      feedback['categories'].hasOwnProperty('categories') &&
      feedback['categories']['categories'].hasOwnProperty(currentIndex) &&
      !_.isEmpty(feedback['categories']['categories'][currentIndex])
    ) {
      this.firstKeywordButton['categories'] = _.keys(
        feedback['categories']['categories'][currentIndex]
      )[0]
    }

    if (
      feedback.hasOwnProperty('seo') &&
      feedback['seo'].hasOwnProperty('keywords') &&
      feedback['seo']['keywords'].hasOwnProperty(currentIndex) &&
      feedback['seo']['keywords'][currentIndex].hasOwnProperty('relevant') &&
      !_.isEmpty(feedback['seo']['keywords'][currentIndex]['relevant'])
    ) {
      let seoKeys = _.keys(
        feedback['seo']['keywords'][currentIndex]['relevant']
      )
      for (let i in seoKeys) {
        if (seoKeys[i]) {
          this.firstKeywordButton['seo'] = seoKeys[i]
          break
        }
      }
    }

    if (
      feedback.hasOwnProperty('skills') &&
      feedback['skills'].hasOwnProperty('relevant_skills_present') &&
      feedback['skills']['relevant_skills_present'].hasOwnProperty(currentIndex)
    ) {
      let flag = false
      let prioritizeSkills = {
        hard_skills: { 1: [], 0.9: [], 0.8: [], 0.7: [], 0.6: [] },
        sub_competency: { 1: [], 0.9: [], 0.8: [], 0.7: [], 0.6: [] },
      }

      for (let skill in feedback['skills']['relevant_skills_present'][
        currentIndex
      ]) {
        for (let k in feedback['skills']['relevant_skills_present'][
          currentIndex
        ][skill]) {
          if (currentSection == 'Skills' || currentSection == 'Headline') {
            if (
              feedback['skills']['relevant_skills_present'][currentIndex][
                skill
              ][k]['state'] == 'stated'
            ) {
              if (
                prioritizeSkills[
                  feedback['skills']['relevant_skills_present'][currentIndex][
                    skill
                  ][k]['type']
                ].hasOwnProperty(
                  feedback['skills']['relevant_skills_present'][currentIndex][
                    skill
                  ][k]['score']
                )
              ) {
                this.firstKeywordButton['skills'] = skill
                flag = true
                break
              }
            }
          } else {
            if (
              prioritizeSkills[
                feedback['skills']['relevant_skills_present'][currentIndex][
                  skill
                ][k]['type']
              ].hasOwnProperty(
                feedback['skills']['relevant_skills_present'][currentIndex][
                  skill
                ][k]['score']
              )
            ) {
              this.firstKeywordButton['skills'] = skill
              flag = true
              break
            }
          }
        }
        if (flag == true) {
          break
        }
      }
    }
  }

  getDefaultSelectedValue(sectionNav, props) {
    let module = ''

    if (sectionNav == 'content') {
      if (this.renderModuleFeedback['categories'] == true) {
        module = 'categories'
      } else if (this.renderModuleFeedback['impact'] == true) {
        module = 'impact'
      } else if (this.renderModuleFeedback['language'] == true) {
        module = 'language'
      } else if (this.renderModuleFeedback['presentation'] == true) {
        module = 'presentation'
      }
    } else if (sectionNav == 'skills') {
      if (this.renderModuleFeedback['skills'] == true) {
        module = 'skills'
      }
    } else if (sectionNav == 'visibility') {
      if (this.renderModuleFeedback['seo'] == true) {
        module = 'seo'
      }
    }

    let value = ''
    let idsObj = null
    const { feedback, currentIndex } = props

    if (module == 'language') {
      value = 'buzzwords'
      if (
        feedback.hasOwnProperty('language') &&
        feedback['language'].hasOwnProperty(value) &&
        feedback['language'][value].hasOwnProperty(currentIndex)
      ) {
        idsObj = feedback['language'][value][currentIndex]
      }
    } else if (module == 'impact') {
      value = 'action_oriented'
      if (
        feedback.hasOwnProperty('impact') &&
        feedback['impact'].hasOwnProperty(value) &&
        feedback['impact'][value].hasOwnProperty(currentIndex)
      ) {
        idsObj = feedback['impact'][value][currentIndex]
      }
    } else if (module == 'categories') {
      value = this.firstKeywordButton['categories']
      if (
        feedback.hasOwnProperty('categories') &&
        feedback['categories'].hasOwnProperty('categories') &&
        feedback['categories']['categories'].hasOwnProperty(currentIndex) &&
        feedback['categories']['categories'][currentIndex].hasOwnProperty(value)
      ) {
        idsObj = feedback['categories']['categories'][currentIndex][value]
      }
    } else if (module == 'skills') {
      value = this.firstKeywordButton['skills']
      if (
        feedback.hasOwnProperty('skills') &&
        feedback['skills'].hasOwnProperty('relevant_skills_present') &&
        feedback['skills']['relevant_skills_present'].hasOwnProperty(
          currentIndex
        ) &&
        feedback['skills']['relevant_skills_present'][
          currentIndex
        ].hasOwnProperty(value)
      ) {
        idsObj =
          feedback['skills']['relevant_skills_present'][currentIndex][value]
      }
    } else if (module == 'seo') {
      value = this.firstKeywordButton['seo']
      if (
        feedback.hasOwnProperty('seo') &&
        feedback['seo'].hasOwnProperty('keywords') &&
        feedback['seo']['keywords'].hasOwnProperty(currentIndex) &&
        feedback['seo']['keywords'][currentIndex].hasOwnProperty('relevant') &&
        feedback['seo']['keywords'][currentIndex]['relevant'].hasOwnProperty(
          value
        )
      ) {
        idsObj = feedback['seo']['keywords'][currentIndex]['relevant'][value]
      }
    } else if (module == 'presentation') {
      value = 'bullet_length'
      idsObj = null
    }

    return { value: value, module: module, idsObj: idsObj }
  }

  renderTop(sectionColor, currentIndex, currentSection) {
    const { tabIndex, sectionWiseActionableContent , intl, isEditModal, selectSection, showEditModal, redirectSelect, fetchId} = this.props
    let sectionTitle = currentSection === 'Summary' ? 'About' : currentSection
    const backbtn = (
      <button className='feedback-panel-back-button' onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        if (isEditModal) {
          showEditModal(false, '')
        }
        selectSection('Overall')
        redirectSelect(fetchId, 'detailed', 'Overall')
        hashLinkScroll()
      }}
      aria-label={intl.formatMessage({ id: "tour.button.back"})}>
        <span className='arrow arrow-right' />
      </button>
    )

    const sectionTitleMessages = {
      Headline: {
        id: "aspire.sections.headline",
        defaultMessage: "Headline"
      },
      About: {
        id: "aspire.sections.about",
        defaultMessage: "About"
      },
      Experience: {
        id: "aspire.sections.experience",
        defaultMessage: "Experience"
      },
      Education: {
        id: "aspire.sections.education",
        defaultMessage: "Education"
      },
    };

    if (this.sectionEmpty == true) {
      return (
        <div className="feedback-panel-top-bar">
          {backbtn}
          <div
            className="top-bar-section-name"
            role="heading"
            aria-level="3"
          >
            {intl.formatMessage(sectionTitleMessages[sectionTitle])}
          </div>
          <div className="top-bar-divider" />
          <div
            className={'top-bar-status text-red'}
            tabIndex={tabIndex}
            aria-label={intl.formatMessage({
              id: "aspire.sections.renderTop.needsWork",
              defaultMessage: "Needs Work!"
            })}>
            {intl.formatMessage({
              id: "aspire.sections.renderTop.needsWork",
              defaultMessage: "Needs Work!"
            })}
          </div>
        </div>
      )
    }

    if (!_.isEmpty(sectionColor)) {
      sectionColor =
        sectionWiseActionableContent[currentSection.toLowerCase()]['zone']
      return (
        <>
          <div className="feedback-panel-top-bar">
            {backbtn}
            <div className="top-bar-section-name">
              {intl.formatMessage(sectionTitleMessages[sectionTitle])}
            </div>
            <div className="top-bar-divider" />
            <div
              className={'top-bar-status text-' + sectionColor}
              tabIndex={tabIndex}
              aria-label={feedbackContent(intl)[sectionColor]['title_text']}>
              {feedbackContent(intl)[sectionColor]['title_text']}
            </div>
          </div>
        </>
      )
    }

    return null
  }

  handleSectionAnimation(payload) {
    this.setState({
      sectionAnimation: payload,
    })
  }

  handlePrev(index, sectionName) {
    this.handleSectionAnimation(false)
    setTimeout(() => {
      const { onSelectPrev, currentSection } = this.props
      onSelectPrev(index, sectionName, currentSection)
      this.handleSectionAnimation(true)
    }, 300)
  }

  handleNext(index, len, sectionName) {
    this.handleSectionAnimation(false)
    setTimeout(() => {
      const { onSelectNext, currentSection } = this.props
      onSelectNext(index, len, sectionName, currentSection)
      this.handleSectionAnimation(true)
    }, 300)
  }

  renderSubsectionChange(currentSection, sectionScore) {
    const {
      feedback,
      sectionWiseTextStatic,
      onSelectIndex,
      currentIndex,
      newSubSection,
      intl,
    } = this.props

    if (
      newSubSection &&
      ['Education', 'Experience', 'Summary'].includes(currentSection)
    ) {
      let descText =
        currentSection === 'Experience'
          ? intl.formatMessage({
              id: "aspire.sections.renderSubsectionChange.experienceDesc",
              defaultMessage: "Please add Job Title and Company details"
            })
          : currentSection === 'Education'
          ? intl.formatMessage({
              id: "aspire.sections.renderSubsectionChange.educationDesc",
              defaultMessage: "Please add School and Degree details"
            })
          : intl.formatMessage({
              id: "aspire.sections.renderSubsectionChange.summaryDesc",
              defaultMessage: "Write about your accomplishments and past experiences and strengthen your first impression on the recruiters."
            })
      return (
        <div className="sub-section-change">
          <div
            className="sub-section-change-desc"
            style={{ width: '100%', paddingLeft: '0px' }}>
            {['Education', 'Experience'].includes(currentSection) ? (
              <div
                className="sub-section-change-title"
                aria-label={currentSection === 'Experience'
                  ? intl.formatMessage({
                      id: "aspire.sections.renderSubsectionChange.newPosition",
                      defaultMessage: "New Position"
                    })
                  : intl.formatMessage({
                      id: "aspire.sections.renderSubsectionChange.newEducation",
                      defaultMessage: "New Education"
                    })
                }>
                <div className="sub-section-change-title-text">
                  {currentSection === 'Experience'
                    ? intl.formatMessage({
                        id: "aspire.sections.renderSubsectionChange.newPosition",
                        defaultMessage: "New Position"
                      })
                    : intl.formatMessage({
                        id: "aspire.sections.renderSubsectionChange.newEducation",
                        defaultMessage: "New Education"
                      })}
                </div>
              </div>
            ) : null}
            <div className="sub-section-change-new-sub-title">
              {descText}
            </div>
          </div>
        </div>
      )
    } else if (['Education', 'Experience'].includes(currentSection)) {
      let subSectionLen = Object.keys(sectionWiseTextStatic).length
      let color = sectionScore[currentIndex]['color']
      let statusDivOverlay = (
        <Popover id="popover-sub-section-status">
          <div className={`overlay-status-text overlay-status-text-${color}`}>
            {this.textMap[color]}
          </div>
          {this.overlayMapDesc[color]}
        </Popover>
      )
      return (
        <div className="sub-section-change">
          <div className="sub-section-change-div">
            <div className="sub-section-change-count">
              {`${parseInt(currentIndex) + 1}/${subSectionLen}`}
            </div>
            <div className="sub-section-change-desc">
              <div
                className="sub-section-change-title"
                aria-label={
                  currentSection === 'Experience'
                    ? sectionWiseTextStatic[currentIndex].company
                    : sectionWiseTextStatic[currentIndex].school
                }>
                <div className="sub-section-change-title-text">
                  {currentSection === 'Experience'
                    ? sectionWiseTextStatic[currentIndex].company
                    : sectionWiseTextStatic[currentIndex].school}
                </div>
                <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement="bottom"
                  rootClose
                  overlay={statusDivOverlay}>
                  <div
                    className={`sub-section-change-status text-${color}`}
                    role="status"
                    aria-label={this.textMap[color]}>
                    <img
                      alt=""
                      src={`${process.env.APP_BASE_URL}dist/images/${iconMap[color]}`}
                      className="feedback-parameter-icon"
                    />
                  </div>
                </OverlayTrigger>
              </div>
              <div className="sub-section-change-sub-title">
                {currentSection === 'Experience'
                  ? sectionWiseTextStatic[currentIndex].title
                  : sectionWiseTextStatic[currentIndex].degree}
              </div>
            </div>
            {subSectionLen !== 1 && (
              <div className="sub-section-change-symbol">
                <div className="sub-section-change-prev">
                  <button
                    className={`sub-section-change-arrow ${
                      parseInt(currentIndex) === 0 ? 'disabled' : ''
                    }`}
                    onClick={() =>
                      this.handlePrev(parseInt(currentIndex), currentSection)
                    }
                    disabled={parseInt(currentIndex) === 0}
                    aria-label={intl.formatMessage({
                      id: "aspire.sections.renderSubsectionChange.clickPrev",
                      defaultMessage: "click here to go to previous sub section, {disabled}",},
                      { disabled: parseInt(currentIndex) === 0 ? "true" : "false" }
                    )}>
                    <div className="arrow arrow-left"></div>
                  </button>
                </div>
                <div className="sub-section-change-next">
                  <button
                    className={`sub-section-change-arrow ${
                      parseInt(currentIndex) >= subSectionLen - 1
                        ? 'disabled'
                        : ''
                    }`}
                    onClick={() =>
                      this.handleNext(
                        parseInt(currentIndex),
                        subSectionLen,
                        currentSection
                      )
                    }
                    disabled={parseInt(currentIndex) >= subSectionLen - 1}
                    aria-label={intl.formatMessage({
                      id: "aspire.sections.renderSubsectionChange.clickNext",
                      defaultMessage: "click here to go to next sub section, {disabled}",},
                      { disabled: parseInt(currentIndex) >= subSectionLen - 1 ? "true" : "false" }
                    )}>
                    <div className="arrow arrow-right"></div>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )
    }

    return null
  }

  renderSubSectionFeedbackSummary(currentSection, sectionScore) {
    const { feedback, sectionWiseTextStatic, onSelectIndex, intl } = this.props
    let subSectionDivs = []
    let subSectionLen = Object.keys(sectionWiseTextStatic).length
    if (!_.isEmpty(sectionScore)) {
      _.mapObject(sectionWiseTextStatic, (value, index) => {
        let totalScore = sectionScore[index]['score']
        let color = sectionScore[index]['color']
        totalScore = parseFloat(totalScore) / 100

        let selectedColor = null
        let backColor = null
        if (color === 'red') {
          selectedColor = '#f34d3d'
          backColor = '#FFF3F2'
        } else if (color === 'yellow') {
          selectedColor = '#ff9e2d'
          backColor = '#FDF5E8'
        } else if (color === 'green') {
          selectedColor = '#46a879'
          backColor = '#E6F1E6'
        }
        let circularOptions = {
          color: selectedColor,
          pathColor: selectedColor,
          strokeWidth: 20,
          trailColor: backColor,
          trailWidth: 20,
          strokeLinecap: 'butt',
        }
        let sectionDiv = (
          <div
            className="sub-section-summary-div"
            data-key={currentSection}
            onClick={(e) =>
              onSelectIndex(
                index,
                subSectionLen,
                currentSection,
                currentSection
              )
            }>
            <div className="sub-section-summary-count">
              {`${parseInt(index) + 1}/${subSectionLen}`}
            </div>
            <div className="sub-section-summary-desc">
              <div
                className="sub-section-summary-title"
                aria-label="Profile Picture">
                {currentSection === 'Experience' ? value.title : value.school}
              </div>
              <div
                className="sub-section-summary-sub-title"
              >
                {currentSection === 'Experience' ? value.company : value.degree}
              </div>
              <div
                className={`sub-section-summary-status text-${color}`}
              >
                {this.textMap[color]}
              </div>
            </div>
            <div className="sub-section-summary-symbol">
              <div className="sub-section-summary-graph">
                <CircularBar
                  className={`sub-section-summary-circular-graph`}
                  value={totalScore * 100}
                  strokeWidth={20}
                  styles={circularOptions}
                />
              </div>
              <div className="sub-section-summary-arrow">
                <div className="arrow arrow-right"></div>
              </div>
            </div>
          </div>
        )
        subSectionDivs.push(sectionDiv)
      })
    }
    return (
      <>
        {_.isEmpty(subSectionDivs) ? (
          <div className="section-feedback">
            <div
              className={`tab-content ${
                (currentSection === 'Education' ||
                  currentSection === 'Experience') &&
                'tab-content-small'
              } ${this.sectionEmpty == true && 'tab-content-empty'}`}>
              {this.renderEmptySection(0, currentSection)}
            </div>
          </div>
        ) : (
          <div className="sub-section-feedback">
            <div className="sub-section-feedback-div">
              <div className="sub-section-feedback-top-text">
                {intl.formatMessage({
                  id: "aspire.sections.renderSubSectionFeedbackSummary.outline",
                  defaultMessage: "Outline of your professional background, knowledge areas and accomplishments"
                })}
              </div>
              <div className="sub-section-feedback-tabs">{subSectionDivs}</div>
            </div>
          </div>
        )}
      </>
    )
  }

  isSectionEmpty(section, sectionData) {
    if (section == 'Summary') {
      if (
        _.isEmpty(sectionData) ||
        (sectionData.hasOwnProperty('text') &&
          sectionData['text'].length == 1 &&
          sectionData['text'][0]['text'][0] == 'N/A')
      ) {
        return true
      }
      return false
    } else {
      if (_.isEmpty(sectionData)) {
        return true
      }
      return false
    }
  }

  renderCommunityNameCheck() {
    const { communityNameCheck, currentSection, feedback, intl } = this.props
    const { community_name_match, community_name } = feedback
    if (
      currentSection !== 'Education' ||
      !communityNameCheck ||
      _.isNull(community_name_match)
    ) {
      return null
    }
    let params = {
      icon: 'alert',
      backgroundClass: 'error',
      componentClass: 'community-notification',
      showBorderBottom: false,
      iconClass: 'col-sm-1',
      content: [
        intl.formatMessage({
          id: "aspire.sections.renderCommunityNameCheck.recommend",
          defaultMessage: "Your community recommends the school name to be written as "
        }),
        <b>“{community_name}”</b>,
      ],
      intl: intl
    }
    if (community_name_match) {
      params.icon = 'tick-2'
      params.backgroundClass = 'success'
    }

    return <InfoComponent {...params} />
  }

  renderEmptySection(currentTab, currentSection) {
    const { intl, pdfLanguage, isUKEnable } = this.props
    let imageLanguage = pdfLanguage
    if(pdfLanguage === 'us' || pdfLanguage === 'uk')
      imageLanguage = 'english'
    return (
      <div
        className="section-feedback-empty"
        id={`empty-section`}
        tabIndex={currentTab}
        aria-label={intl.formatMessage({
          id: "aspire.sections.renderEmptySection.ariaLabel",
          defaultMessage: "Write content to unlock the feedback for this section"
        })}>
        <div className="empty-section-top-header">
          <div className="empty-section-top-img">
            <img
              alt="empty section icon"
              className="empty-section-icon"
              src={getLanguageSpecificAssetUrl(`info_empty_${currentSection.toLowerCase()}.svg`, imageLanguage, 'images', 'aspire')}
            />
          </div>
          <div className="empty-section-top-heading">
            {intl.formatMessage({
              id: "aspire.sections.renderEmptySection.notIncluded",
              defaultMessage: "You have not included this section!"
            })}
          </div>
          <div className="empty-section-top-sub-heading">
            {intl.formatMessage({
              id: "aspire.sections.renderEmptySection.addContent",
              defaultMessage: "Add content to get feedback for this section"
            })}
          </div>
        </div>
        <div className="empty-section-bottom-info">
          <ul className="empty-section-bottom-info-list-div" tabIndex={0}>
            <li className="empty-section-bottom-info-list">
              <div className="empty-section-bottom-info-bullet"></div>
              {emptySectionMessage(intl, isUKEnable)[currentSection][0]}
            </li>
            <li className="empty-section-bottom-info-list">
              <div className="empty-section-bottom-info-bullet"></div>
              {emptySectionMessage(intl, isUKEnable)[currentSection][1]}
            </li>
            {currentSection === 'Experience' && (
              <li className="empty-section-bottom-info-list">
                <div className="empty-section-bottom-info-bullet"></div>
                {emptySectionMessage(intl, isUKEnable)[currentSection][2]}
              </li>
            )}
          </ul>
        </div>
      </div>
    )
  }

  render() {
    const {
      ui,
      derivedSkills,
      resumeSkillsInLinkedin,
      resumeSkillsNotInLinkedin,
      suggestedSkills,
      sectionWiseTextEditable,
      sectionWiseText,
      sectionsPerSkill,
      currentSection,
      has_api,
      has_pdf,
      feedback,
      staticFeedback,
      unhighlightAll,
      activeNavIndex,
      tabIndex,
      isUKEnable,
      newSubSection,
      newSectionSuggestedSkills,
      isEditModal,
      intl,
      isGenAiFeedback,
    } = this.props
    const { sectionAnimation } = this.state
    let currentTab = tabIndex
    const currentIndex = ui.currentIndex
    let contentOutput = []
    let skillsOutput = []
    let liNavs = []
    let liDivs = []
    if (newSubSection && isEditModal) {
      for (let i in sectionNavs[currentSection]) {
        if (sectionNavs[currentSection][i] == 'content') {
          let k = 0
          let t = this.renderNewSuggestedCategories(currentSection)

          if (!_.isNull(t)) {
            contentOutput.push(<div key={k++}>{t}</div>)
          }
          t = this.renderImpactZero(currentSection)

          if (!_.isNull(t)) {
            contentOutput.push(<div key={k++}>{t}</div>)
          }
          
          if(isGenAiFeedback){
            t = this.renderPresentationZero(currentSection)
            if (!_.isNull(t)) {
              contentOutput.push(<div key={k++}>{t}</div>)
            }
          }

          contentOutput.splice(contentOutput.length, 1)
          liDivs.push(
            <div
              key={i}
              role="tabpanel"
              aria-labelledby={`parameters-navigation-tablist-${i}`}
              className={classNames(
                'tab-pane',
                'params-detailed-feedback',
                'fade',
                { show: i == activeNavIndex },
                { active: i == activeNavIndex }
              )}
              id="content">
              {contentOutput}
            </div>
          )
        } else if (sectionNavs[currentSection][i] == 'skills') {
          let k = 0
          let t = this.renderNewSuggestedSkills(
            currentSection,
            currentIndex,
            currentTab
          )
          if (!_.isNull(t)) {
            skillsOutput.push(<div key={k++}>{t}</div>)
          }

          liDivs.push(
            <div
              key={i}
              role="tabpanel"
              aria-labelledby={`parameters-navigation-tablist-${i}`}
              className={classNames(
                'tab-pane',
                'params-detailed-feedback',
                'fade',
                { show: i == activeNavIndex },
                { active: i == activeNavIndex }
              )}
              id="skills">
              {skillsOutput}
            </div>
          )
        } else if (sectionNavs[currentSection][i] == 'visibility') {
          liDivs.push(
            <div
              key={i}
              role="tabpanel"
              aria-labelledby={`parameters-navigation-tablist-${i}`}
              className={classNames(
                'tab-pane',
                'params-detailed-feedback',
                'fade',
                { show: i == activeNavIndex },
                { active: i == activeNavIndex }
              )}
              id="visibility">
              {this.renderNewSuggestedSeo(
                feedback,
                currentSection,
                currentIndex,
                currentTab
              )}
            </div>
          )
        }

        liNavs.push(
          <li
            key={i}
            id={`parameters-navigation-tablist-${i}`}
            className={classNames({ active: i == activeNavIndex })}
            role="presentation">
            <a
              role="tab"
              aria-controls={sectionNavs[currentSection][i]}
              onClick={(e) => this.handleClick(e)}
              data-navindex={i}
              data-bs-toggle="tab">
              {intl.formatMessage(
                modsMessages[sectionNavs[currentSection][i]]
              )}
            </a>
          </li>
        )
      }
    } else if (this.sectionEmpty !== true) {
      for (let i in sectionNavs[currentSection]) {
        let sectionNavScoreClass = this.getSectionNavScore(
          sectionNavs[currentSection][i],
          currentSection,
          currentIndex
        )
        if (sectionNavs[currentSection][i] == 'content') {
          let k = 0

          let t = this.renderCategoriesFeedback(
            feedback,
            currentSection,
            currentIndex,
            currentTab
          )

          if (!_.isNull(t)) {
            contentOutput.push(<div key={k++}>{t}</div>)
          }

          t = this.renderImpactFeedback(feedback, currentSection, currentIndex)

          if (_.isNull(t)) {
            t = this.renderImpactZero(currentSection)
          }
          if (!_.isNull(t)) {
            contentOutput.push(<div key={k++}>{t}</div>)
          }

          if(isGenAiFeedback){
            t = this.renderPresentationFeedback(feedback, currentSection, currentIndex)
            if (_.isNull(t)) {
              t = this.renderPresentationZero(currentSection)
            }
            if (!_.isNull(t)) {
              contentOutput.push(<div key={k++}>{t}</div>)
            }
          }

          contentOutput.splice(contentOutput.length, 1)
          liDivs.push(
            <div
              key={i}
              role="tabpanel"
              aria-labelledby={`parameters-navigation-tablist-${i}`}
              className={classNames(
                'tab-pane',
                'params-detailed-feedback',
                'fade',
                { show: i == activeNavIndex },
                { active: i == activeNavIndex }
              )}
              id="content">
              {contentOutput}
            </div>
          )
        } else if (sectionNavs[currentSection][i] == 'skills') {
          let k = 0
          let t = this.renderSkillsFeedback(
            feedback,
            sectionsPerSkill,
            currentSection,
            currentIndex,
            resumeSkillsInLinkedin,
            resumeSkillsNotInLinkedin,
            suggestedSkills,
            derivedSkills,
            currentTab,
            newSectionSuggestedSkills
          )
          if (!_.isNull(t)) {
            skillsOutput.push(<div key={k++}>{t}</div>)
          }
          if (['Summary', 'Experience'].includes(currentSection)) {
            t = this.getResumeSkills()
            if (!_.isNull(t)) {
              skillsOutput.push(<div key={k++}>{t}</div>)
            }
          }

          skillsOutput.splice(skillsOutput.length, 1)

          liDivs.push(
            <div
              key={i}
              role="tabpanel"
              aria-labelledby={`parameters-navigation-tablist-${i}`}
              className={classNames(
                'tab-pane',
                'params-detailed-feedback',
                'fade',
                { show: i == activeNavIndex },
                { active: i == activeNavIndex }
              )}
              id="skills">
              {skillsOutput}
            </div>
          )
        } else if (sectionNavs[currentSection][i] == 'visibility') {
          liDivs.push(
            <div
              key={i}
              role="tabpanel"
              aria-labelledby={`parameters-navigation-tablist-${i}`}
              className={classNames(
                'tab-pane',
                'params-detailed-feedback',
                'fade',
                { show: i == activeNavIndex },
                { active: i == activeNavIndex }
              )}
              id="visibility">
              {this.renderSeoFeedback(
                feedback,
                currentSection,
                currentIndex,
                currentTab
              )}
            </div>
          )
        }

        let sectionNavOverlay = (
          <Popover id="popover-left-nav-icon">
            {this.textMap[sectionNavScoreClass]}
          </Popover>
        )

        liNavs.push(
          <li
            key={i}
            id={`parameters-navigation-tablist-${i}`}
            className={classNames({ active: i == activeNavIndex })}
            role="presentation">
            <a
              role="tab"
              aria-controls={sectionNavs[currentSection][i]}
              onClick={(e) => this.handleClick(e)}
              data-navindex={i}
              data-bs-toggle="tab">
              {intl.formatMessage(
                modsMessages[sectionNavs[currentSection][i]]
              )}
              <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="bottom"
                rootClose
                overlay={sectionNavOverlay}>
                <img
                  alt={this.textMap[sectionNavScoreClass]}
                  src={`${process.env.APP_BASE_URL}dist/images/${iconMap[sectionNavScoreClass]}`}
                  className="feedback-parameter-icon"
                  aria-label={this.textMap[sectionNavScoreClass]}
                />
              </OverlayTrigger>
            </a>
          </li>
        )
      }
    } else {
      liDivs.push(this.renderEmptySection(currentTab, currentSection))
    }

    let infoComponent = null

    if (this.state.showInfoScreen == true) {
      infoComponent = (
        <InfoScreens
          tabIndex={currentTab}
          show={this.state.showInfoScreen}
          module={this.state.activeInfoScreen}
          currentSection={currentSection}
          hideModal={this.hideInfoModal}
          isUKEnable={isUKEnable}
        />
      )
    }
    return (
      <div>
        {infoComponent}
        <div className="feedback-panel">
          <div>
            {this.renderTop(
              feedback['section_score'],
              currentIndex,
              currentSection
            )}
          </div>
          {(currentIndex === null || _.isEmpty(feedback['section_score'])) &&
          !(newSubSection && isEditModal) ? (
            this.renderSubSectionFeedbackSummary(
              currentSection,
              feedback['section_score']
            )
          ) : (
            <>
              {this.renderSubsectionChange(
                currentSection,
                feedback['section_score']
              )}
              <div
                className={`section-feedback ${
                  sectionAnimation
                    ? 'section_feedback_animation_open'
                    : 'section_feedback_animation_close'
                }`}>
                {(this.sectionEmpty !== true || newSubSection) && (
                  <ul
                    className="nav nav-tabs"
                    id="parameters-navigation-tab"
                    role="tablist"
                    tabIndex={0}
                    style = {{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '0 10px',
                    }}
                  >
                    {liNavs}
                  </ul>
                )}
                <div
                  className={`tab-content ${
                    ['Education', 'Experience', 'Summary'].includes(
                      currentSection
                    ) && 'tab-content-small'
                  } ${
                    this.sectionEmpty == true &&
                    !newSubSection &&
                    'tab-content-empty'
                  }`}
                  style = {['Summary'].includes(
                      currentSection) ? { maxHeight: 'calc(100vh - 241px)' } : {} }
                  id="parameters-navigation-content">
                  {liDivs}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    )
  }
}
function mapStateToProps(state, ownProps) {
  return {
    communityName: state.user.data.communityName,
    isUKEnable: state.aspireFeedbackData.ukEnglish,
    removeBulletPointSuggestion: fetchCustomisation(
      state.AspireCommunityCustomization.data,
      'remove_bullet_point_suggestion'
    ),
    communityNameCheck: fetchCustomisation(
      state.AspireCommunityCustomization.data,
      'community_name_check'
    ),
    user: state.user.data,
    sectionWiseActionableContent:
      state.aspireFeedbackData.data.section_wise_actionable_content,
    section_wise_feedback: state.aspireFeedbackData.data.section_wise_feedback,
    fetchingSkills: state.aspireEditDynamicData.fetchingSkills,
    fetchedSkills: state.aspireEditDynamicData.fetchedSkills,
    errorSkills: state.aspireEditDynamicData.errorSkills,
    dataSkills: state.aspireEditDynamicData.dataSkills,
    sectionWiseTextIntermediateSkills:
      state.aspireEditDynamicData.sectionWiseTextIntermediateSkills,
    fetchingResumeGaps: state.aspireResumeGapData.fetching,
    fetchedResumeGaps: state.aspireResumeGapData.fetched,
    errorResumeGaps: state.aspireResumeGapData.error,
    dataResumeGaps: state.aspireResumeGapData.data,
    hasResume: state.aspireFeedbackData.has_resume,
    loaderInput: state.aspireFeedbackData.mini_loader_text,
    suggestedSkills: state.detailedFeedbackUi.suggestedSkills,
    newSectionSuggestedSkills:
      state.detailedFeedbackUi.newSectionSuggestedSkills,
    normalResume: state.aspireFeedbackData.normalResume,
    dataContent: state.aspireEditDynamicData.dataContent,
    isEditModal: state.editData.show_edit_modal,
    isGenAiFeedback: state.aspireFeedbackData.isGenAiFeedback,
    pdfLanguage: state.aspireFeedbackData.pdf_language,
  }
}

export default connect(mapStateToProps, {
  fetchResumeGap,
  updateResumeGapState,
  showEditModal,
  redirectSelect,
  selectSection,
})(injectIntl(Sections))
